// Code generated by tygo. DO NOT EDIT.

//////////
// source: types.go

/**
 * ActivityType describes the kind of feed activity item.
 */
export const ActivityTypeComment = "comment";
export const ActivityTypeRSVP = "rsvp";
export const ActivityTypeFollow = "follow";
export const ActivityTypeHost = "host";
export const ActivityTypeReminder = "reminder";
export type ActivityType = typeof ActivityTypeComment | typeof ActivityTypeRSVP | typeof ActivityTypeFollow | typeof ActivityTypeHost | typeof ActivityTypeReminder;
export const FriendActivityTypeRSVP = "friend_rsvp";
export const FriendActivityTypeSave = "friend_save";
export const FriendActivityTypeFollow = "friend_follow";
export type FriendActivityType = typeof FriendActivityTypeRSVP | typeof FriendActivityTypeSave | typeof FriendActivityTypeFollow;
export const ChangelogTypeBackstage = "backstage";
export const ChangelogTypeApp = "app";
export type ChangelogType = typeof ChangelogTypeBackstage | typeof ChangelogTypeApp;
/**
 * APIErrorCode is a stable machine-readable code clients can use for recovery,
 * field focus, analytics, or Sentry grouping. The top-level error message remains
 * the human-readable copy.
 */
export const APIErrorCodeInvalidInput = "invalid_input";
export const APIErrorCodeUnauthorized = "unauthorized";
export const APIErrorCodeAuthMissing = "auth_missing";
export const APIErrorCodeSessionExpired = "session_expired";
export const APIErrorCodeInvalidToken = "invalid_token";
export const APIErrorCodeInvalidCredentials = "invalid_credentials";
export const APIErrorCodeForbidden = "forbidden";
export const APIErrorCodeNotFound = "not_found";
export const APIErrorCodeConflict = "conflict";
export const APIErrorCodeInvalidJSON = "invalid_json";
export const APIErrorCodeMissingRequiredField = "missing_required_field";
export const APIErrorCodeInvalidField = "invalid_field";
export const APIErrorCodeEmailTaken = "email_taken";
export const APIErrorCodeUsernameTaken = "username_taken";
export const APIErrorCodeRateLimited = "rate_limited";
export const APIErrorCodeReadOnlyMarket = "read_only_market";
export const APIErrorCodeEventArchived = "event_archived";
export const APIErrorCodeEventAtCapacity = "event_at_capacity";
export const APIErrorCodeEventScheduleInvalid = "event_schedule_invalid";
export const APIErrorCodeEventPosterRequired = "event_poster_required";
export const APIErrorCodeModerationRejected = "moderation_rejected";
export const APIErrorCodeModerationUnavailable = "moderation_unavailable";
export const APIErrorCodeUnsupportedUploadType = "unsupported_upload_type";
export const APIErrorCodeUploadTooLarge = "upload_too_large";
export const APIErrorCodeUploadFailed = "upload_failed";
export const APIErrorCodeStorageUnavailable = "storage_unavailable";
export const APIErrorCodeUpstreamUnavailable = "upstream_unavailable";
export const APIErrorCodeInternal = "internal_error";
export type APIErrorCode = typeof APIErrorCodeInvalidInput | typeof APIErrorCodeUnauthorized | typeof APIErrorCodeAuthMissing | typeof APIErrorCodeSessionExpired | typeof APIErrorCodeInvalidToken | typeof APIErrorCodeInvalidCredentials | typeof APIErrorCodeForbidden | typeof APIErrorCodeNotFound | typeof APIErrorCodeConflict | typeof APIErrorCodeInvalidJSON | typeof APIErrorCodeMissingRequiredField | typeof APIErrorCodeInvalidField | typeof APIErrorCodeEmailTaken | typeof APIErrorCodeUsernameTaken | typeof APIErrorCodeRateLimited | typeof APIErrorCodeReadOnlyMarket | typeof APIErrorCodeEventArchived | typeof APIErrorCodeEventAtCapacity | typeof APIErrorCodeEventScheduleInvalid | typeof APIErrorCodeEventPosterRequired | typeof APIErrorCodeModerationRejected | typeof APIErrorCodeModerationUnavailable | typeof APIErrorCodeUnsupportedUploadType | typeof APIErrorCodeUploadTooLarge | typeof APIErrorCodeUploadFailed | typeof APIErrorCodeStorageUnavailable | typeof APIErrorCodeUpstreamUnavailable | typeof APIErrorCodeInternal;
export interface APIFieldError {
  field: string;
  code: APIErrorCode;
  message: string;
}
export interface APIErrorResponse {
  error: string;
  code?: APIErrorCode;
  field_errors?: APIFieldError[];
  request_id?: string;
}
/**
 * ProfileVisibility controls who can view a profile.
 */
export const ProfileVisibilityPublic = "public";
export const ProfileVisibilityFriends = "friends";
export type ProfileVisibility = typeof ProfileVisibilityPublic | typeof ProfileVisibilityFriends;
/**
 * PublicProfileVisibility indicates how much of a public profile response is visible to the viewer.
 */
export const PublicProfileVisibilityFull = "full";
export const PublicProfileVisibilityLimited = "limited";
export type PublicProfileVisibility = typeof PublicProfileVisibilityFull | typeof PublicProfileVisibilityLimited;
export const RSVPVisibilityPublic = "public";
export const RSVPVisibilityFriends = "friends";
export const RSVPVisibilityPrivate = "private";
export type RSVPVisibility = typeof RSVPVisibilityPublic | typeof RSVPVisibilityFriends | typeof RSVPVisibilityPrivate;
/**
 * EventAgeRestriction indicates the venue admission requirement.
 */
export const EventAgeRestrictionAllAges = "all_ages";
export const EventAgeRestriction18Plus = "18_plus";
export const EventAgeRestriction21Plus = "21_plus";
export type EventAgeRestriction = typeof EventAgeRestrictionAllAges | typeof EventAgeRestriction18Plus | typeof EventAgeRestriction21Plus;
export const EntryTypeFree = "free";
export const EntryTypeCover = "cover";
export const EntryTypeTicketed = "ticketed";
export const EntryTypeRSVP = "rsvp";
export const EntryTypeFreeRSVP = "free_rsvp";
export type EntryType = typeof EntryTypeFree | typeof EntryTypeCover | typeof EntryTypeTicketed | typeof EntryTypeRSVP | typeof EntryTypeFreeRSVP;
export const FeedTagGroupMusic = "music";
export const FeedTagGroupDancing = "dancing";
export const FeedTagGroupLowKey = "low_key";
export const FeedTagGroupFoodDrink = "food_drink";
export const FeedTagGroupArtsCulture = "arts_culture";
export const FeedTagGroupOutside = "outside";
export const FeedTagGroupSocial = "social";
export const FeedTagGroupLateNight = "late_night";
export type FeedTagGroup = typeof FeedTagGroupMusic | typeof FeedTagGroupDancing | typeof FeedTagGroupLowKey | typeof FeedTagGroupFoodDrink | typeof FeedTagGroupArtsCulture | typeof FeedTagGroupOutside | typeof FeedTagGroupSocial | typeof FeedTagGroupLateNight;
export const EventFormatPerformance = "performance";
export const EventFormatClass = "class";
export const EventFormatMarket = "market";
export const EventFormatSports = "sports";
export const EventFormatPopup = "popup";
export const EventFormatParty = "party";
export const EventFormatNetworking = "networking";
export type EventFormat = typeof EventFormatPerformance | typeof EventFormatClass | typeof EventFormatMarket | typeof EventFormatSports | typeof EventFormatPopup | typeof EventFormatParty | typeof EventFormatNetworking;
export const EventSourceManual = "manual";
export const EventSourceFixtureGenerated = "fixture_generated";
export const EventSourceExtracted = "extracted";
export const EventSourceImported = "imported";
export type EventSource = typeof EventSourceManual | typeof EventSourceFixtureGenerated | typeof EventSourceExtracted | typeof EventSourceImported;
export const EventCanonicalOwnerTypeUser = "user";
export const EventCanonicalOwnerTypeOrganization = "organization";
export type EventCanonicalOwnerType = typeof EventCanonicalOwnerTypeUser | typeof EventCanonicalOwnerTypeOrganization;
export const VenueStagingOrganizationSlug = "radious-venue-staging";
export const VenueStagingOrganizationName = "Radious Venue Staging";
export type VenueStagingOrganization = typeof VenueStagingOrganizationSlug | typeof VenueStagingOrganizationName;
export const EventTagCategoryGroupMusic = "music";
export const EventTagCategoryGroupFoodDrink = "food_drink";
export const EventTagCategoryGroupEntertainment = "entertainment";
export const EventTagCategoryGroupArtsCulture = "arts_culture";
export const EventTagCategoryGroupNightlife = "nightlife";
export const EventTagCategoryGroupCommunity = "community";
export const EventTagCategoryGroupIdentity = "identity";
export const EventTagCategoryGroupSetting = "setting";
export const EventTagCategoryGroupAttire = "attire";
export const EventTagCategoryGroupOther = "other";
export type EventTagCategoryGroup = typeof EventTagCategoryGroupMusic | typeof EventTagCategoryGroupFoodDrink | typeof EventTagCategoryGroupEntertainment | typeof EventTagCategoryGroupArtsCulture | typeof EventTagCategoryGroupNightlife | typeof EventTagCategoryGroupCommunity | typeof EventTagCategoryGroupIdentity | typeof EventTagCategoryGroupSetting | typeof EventTagCategoryGroupAttire | typeof EventTagCategoryGroupOther;
export const VenueCategoryMusicVenue = "music_venue";
export const VenueCategoryBar = "bar";
export const VenueCategoryDiveBar = "dive_bar";
export const VenueCategoryWineBar = "wine_bar";
export const VenueCategorySpeakeasy = "speakeasy";
export const VenueCategoryNightclub = "nightclub";
export const VenueCategoryBrewery = "brewery";
export const VenueCategoryDistillery = "distillery";
export const VenueCategoryRooftop = "rooftop";
export const VenueCategorySportsBar = "sports_bar";
export const VenueCategoryLounge = "lounge";
export const VenueCategoryComedyClub = "comedy_club";
export const VenueCategoryKaraoke = "karaoke";
export const VenueCategoryHookahLounge = "hookah_lounge";
export const VenueCategoryPoolHall = "pool_hall";
export const VenueCategoryGayBar = "gay_bar";
export const VenueCategoryOther = "other";
export type VenueCategory = typeof VenueCategoryMusicVenue | typeof VenueCategoryBar | typeof VenueCategoryDiveBar | typeof VenueCategoryWineBar | typeof VenueCategorySpeakeasy | typeof VenueCategoryNightclub | typeof VenueCategoryBrewery | typeof VenueCategoryDistillery | typeof VenueCategoryRooftop | typeof VenueCategorySportsBar | typeof VenueCategoryLounge | typeof VenueCategoryComedyClub | typeof VenueCategoryKaraoke | typeof VenueCategoryHookahLounge | typeof VenueCategoryPoolHall | typeof VenueCategoryGayBar | typeof VenueCategoryOther;
export const VenueSocialPlatformInstagram = "instagram";
export const VenueSocialPlatformTiktok = "tiktok";
export const VenueSocialPlatformFacebook = "facebook";
export const VenueSocialPlatformX = "x";
export const VenueSocialPlatformSpotify = "spotify";
export const VenueSocialPlatformYoutube = "youtube";
export const VenueSocialPlatformLinktree = "linktree";
export type VenueSocialPlatform = typeof VenueSocialPlatformInstagram | typeof VenueSocialPlatformTiktok | typeof VenueSocialPlatformFacebook | typeof VenueSocialPlatformX | typeof VenueSocialPlatformSpotify | typeof VenueSocialPlatformYoutube | typeof VenueSocialPlatformLinktree;
export const VenueWeekdayMonday = "monday";
export const VenueWeekdayTuesday = "tuesday";
export const VenueWeekdayWednesday = "wednesday";
export const VenueWeekdayThursday = "thursday";
export const VenueWeekdayFriday = "friday";
export const VenueWeekdaySaturday = "saturday";
export const VenueWeekdaySunday = "sunday";
export type VenueWeekday = typeof VenueWeekdayMonday | typeof VenueWeekdayTuesday | typeof VenueWeekdayWednesday | typeof VenueWeekdayThursday | typeof VenueWeekdayFriday | typeof VenueWeekdaySaturday | typeof VenueWeekdaySunday;
export const OrgRoleOwner = "owner";
export const OrgRoleManager = "manager";
export const OrgRoleSocial = "social";
export const OrgRoleStaff = "staff";
export type OrgRole = typeof OrgRoleOwner | typeof OrgRoleManager | typeof OrgRoleSocial | typeof OrgRoleStaff;
export const OrgActivityEventTypeOrganizationInviteSent = "organization_invite_sent";
export const OrgActivityEventTypeOrganizationInviteRevoked = "organization_invite_revoked";
export const OrgActivityEventTypeOrganizationInviteAccepted = "organization_invite_accepted";
export const OrgActivityEventTypeOrganizationMemberRoleUpdated = "organization_member_role_updated";
export const OrgActivityEventTypeOrganizationMemberScopeUpdated = "organization_member_scope_updated";
export const OrgActivityEventTypeOrganizationMemberRemoved = "organization_member_removed";
export const OrgActivityEventTypeVenueClaimApproved = "venue_claim_approved";
export const OrgActivityEventTypeOwnerHandoffStarted = "owner_handoff_started";
export const OrgActivityEventTypeOwnerSetupCompleted = "owner_setup_completed";
export const OrgActivityEventTypeVenueSetupCompleted = "venue_setup_completed";
export const OrgActivityEventTypeVenueAnnouncementSent = "venue_announcement_sent";
export const OrgActivityEventTypeEventBoostStarted = "event_boost_started";
export const OrgActivityEventTypeBillingPlanChanged = "billing_plan_changed";
export const OrgActivityEventTypeBillingGracePeriodStarted = "billing_grace_period_started";
export const OrgActivityEventTypeBillingPaidFeaturesPaused = "billing_paid_features_paused";
export const OrgActivityEventTypeBillingReactivated = "billing_reactivated";
export const OrgActivityEventTypeBillingCancellationScheduled = "billing_cancellation_scheduled";
export const OrgActivityEventTypeBillingSubscriptionEnded = "billing_subscription_ended";
export const OrgActivityEventTypeEventCreated = "event_created";
export const OrgActivityEventTypeEventEdited = "event_edited";
export const OrgActivityEventTypeEventPublished = "event_published";
export const OrgActivityEventTypeEventPosterUpdated = "event_poster_updated";
export const OrgActivityEventTypeEventCancelled = "event_cancelled";
export const OrgActivityEventTypeEventDeleted = "event_deleted";
export const OrgActivityEventTypeEventDuplicated = "event_duplicated";
export const OrgActivityEventTypeEventBoostUpgraded = "event_boost_upgraded";
export const OrgActivityEventTypeEventBoostExpired = "event_boost_expired";
export const OrgActivityEventTypeFixtureCreated = "fixture_created";
export const OrgActivityEventTypeFixtureEdited = "fixture_edited";
export const OrgActivityEventTypeFixturePaused = "fixture_paused";
export const OrgActivityEventTypeFixtureResumed = "fixture_resumed";
export const OrgActivityEventTypeFixtureDeleted = "fixture_deleted";
export const OrgActivityEventTypeFixtureAppliedToUpcoming = "fixture_applied_to_upcoming";
export const OrgActivityEventTypeFixtureRepaired = "fixture_repaired";
export const OrgActivityEventTypeFixtureRestored = "fixture_restored";
export const OrgActivityEventTypeFixtureGeneratedEvent = "fixture_generated_event";
export const OrgActivityEventTypeFixtureGeneratedEventSkipped = "fixture_generated_event_skipped";
export const OrgActivityEventTypeFixtureGeneratedEventProtected = "fixture_generated_event_protected";
export const OrgActivityEventTypeDealCreated = "deal_created";
export const OrgActivityEventTypeDealEdited = "deal_edited";
export const OrgActivityEventTypeDealDeactivated = "deal_deactivated";
export const OrgActivityEventTypeDealReactivated = "deal_reactivated";
export const OrgActivityEventTypeDealDeleted = "deal_deleted";
export const OrgActivityEventTypeVenueProfileEdited = "venue_profile_edited";
export const OrgActivityEventTypeVenueSubmittedForReview = "venue_submitted_for_review";
export const OrgActivityEventTypeVenueApproved = "venue_approved";
export const OrgActivityEventTypeOrganizationNameChanged = "organization_name_changed";
export const OrgActivityEventTypeOrganizationSlugChanged = "organization_slug_changed";
export const OrgActivityEventTypeOrganizationSetupCompleted = "organization_setup_completed";
export const OrgActivityEventTypeOrganizationInviteExpired = "organization_invite_expired";
export const OrgActivityEventTypeBillingPaymentMethodUpdated = "billing_payment_method_updated";
export const OrgActivityEventTypeBillingTrialStarted = "billing_trial_started";
export const OrgActivityEventTypeBillingTrialEnded = "billing_trial_ended";
export type OrgActivityEventType = typeof OrgActivityEventTypeOrganizationInviteSent | typeof OrgActivityEventTypeOrganizationInviteRevoked | typeof OrgActivityEventTypeOrganizationInviteAccepted | typeof OrgActivityEventTypeOrganizationMemberRoleUpdated | typeof OrgActivityEventTypeOrganizationMemberScopeUpdated | typeof OrgActivityEventTypeOrganizationMemberRemoved | typeof OrgActivityEventTypeVenueClaimApproved | typeof OrgActivityEventTypeOwnerHandoffStarted | typeof OrgActivityEventTypeOwnerSetupCompleted | typeof OrgActivityEventTypeVenueSetupCompleted | typeof OrgActivityEventTypeVenueAnnouncementSent | typeof OrgActivityEventTypeEventBoostStarted | typeof OrgActivityEventTypeBillingPlanChanged | typeof OrgActivityEventTypeBillingGracePeriodStarted | typeof OrgActivityEventTypeBillingPaidFeaturesPaused | typeof OrgActivityEventTypeBillingReactivated | typeof OrgActivityEventTypeBillingCancellationScheduled | typeof OrgActivityEventTypeBillingSubscriptionEnded | typeof OrgActivityEventTypeEventCreated | typeof OrgActivityEventTypeEventEdited | typeof OrgActivityEventTypeEventPublished | typeof OrgActivityEventTypeEventPosterUpdated | typeof OrgActivityEventTypeEventCancelled | typeof OrgActivityEventTypeEventDeleted | typeof OrgActivityEventTypeEventDuplicated | typeof OrgActivityEventTypeEventBoostUpgraded | typeof OrgActivityEventTypeEventBoostExpired | typeof OrgActivityEventTypeFixtureCreated | typeof OrgActivityEventTypeFixtureEdited | typeof OrgActivityEventTypeFixturePaused | typeof OrgActivityEventTypeFixtureResumed | typeof OrgActivityEventTypeFixtureDeleted | typeof OrgActivityEventTypeFixtureAppliedToUpcoming | typeof OrgActivityEventTypeFixtureRepaired | typeof OrgActivityEventTypeFixtureRestored | typeof OrgActivityEventTypeFixtureGeneratedEvent | typeof OrgActivityEventTypeFixtureGeneratedEventSkipped | typeof OrgActivityEventTypeFixtureGeneratedEventProtected | typeof OrgActivityEventTypeDealCreated | typeof OrgActivityEventTypeDealEdited | typeof OrgActivityEventTypeDealDeactivated | typeof OrgActivityEventTypeDealReactivated | typeof OrgActivityEventTypeDealDeleted | typeof OrgActivityEventTypeVenueProfileEdited | typeof OrgActivityEventTypeVenueSubmittedForReview | typeof OrgActivityEventTypeVenueApproved | typeof OrgActivityEventTypeOrganizationNameChanged | typeof OrgActivityEventTypeOrganizationSlugChanged | typeof OrgActivityEventTypeOrganizationSetupCompleted | typeof OrgActivityEventTypeOrganizationInviteExpired | typeof OrgActivityEventTypeBillingPaymentMethodUpdated | typeof OrgActivityEventTypeBillingTrialStarted | typeof OrgActivityEventTypeBillingTrialEnded;
export const OrgActivityActorKindUser = "user";
export const OrgActivityActorKindAdmin = "admin";
export const OrgActivityActorKindSystem = "system";
export type OrgActivityActorKind = typeof OrgActivityActorKindUser | typeof OrgActivityActorKindAdmin | typeof OrgActivityActorKindSystem;
export const OrgActivityEntityTypeOrganization = "organization";
export const OrgActivityEntityTypeVenue = "venue";
export const OrgActivityEntityTypeEvent = "event";
export const OrgActivityEntityTypeFixture = "fixture";
export const OrgActivityEntityTypeDeal = "deal";
export const OrgActivityEntityTypeMember = "member";
export const OrgActivityEntityTypeInvite = "invite";
export const OrgActivityEntityTypeBilling = "billing";
export const OrgActivityEntityTypeBoost = "boost";
export type OrgActivityEntityType = typeof OrgActivityEntityTypeOrganization | typeof OrgActivityEntityTypeVenue | typeof OrgActivityEntityTypeEvent | typeof OrgActivityEntityTypeFixture | typeof OrgActivityEntityTypeDeal | typeof OrgActivityEntityTypeMember | typeof OrgActivityEntityTypeInvite | typeof OrgActivityEntityTypeBilling | typeof OrgActivityEntityTypeBoost;
export const VenueClaimRoleOwner = "owner";
export const VenueClaimRoleGeneralManager = "general_manager";
export const VenueClaimRoleMarketingSocial = "marketing_social";
export const VenueClaimRoleTalentBuyer = "talent_buyer";
export const VenueClaimRoleOther = "other";
export type VenueClaimRole = typeof VenueClaimRoleOwner | typeof VenueClaimRoleGeneralManager | typeof VenueClaimRoleMarketingSocial | typeof VenueClaimRoleTalentBuyer | typeof VenueClaimRoleOther;
export const VenueClaimTypeExistingVenueClaim = "existing_venue_claim";
export const VenueClaimTypeNewVenueSubmission = "new_venue_submission";
export type VenueClaimType = typeof VenueClaimTypeExistingVenueClaim | typeof VenueClaimTypeNewVenueSubmission;
export const VenueClaimMarketReviewStatusPending = "pending";
export const VenueClaimMarketReviewStatusSupported = "supported";
export const VenueClaimMarketReviewStatusOutsideSupportedMarket = "outside_supported_market";
export const VenueClaimMarketReviewStatusUnresolved = "unresolved";
export type VenueClaimMarketReviewStatus = typeof VenueClaimMarketReviewStatusPending | typeof VenueClaimMarketReviewStatusSupported | typeof VenueClaimMarketReviewStatusOutsideSupportedMarket | typeof VenueClaimMarketReviewStatusUnresolved;
export type WaitlistEntrySource = string;
export const WaitlistEntrySourceVenueSubmission: WaitlistEntrySource = "venue_submission";
export const VenueVerificationMethodOfficialEmail = "official_email";
export const VenueVerificationMethodOfficialSocial = "official_social";
export const VenueVerificationMethodBusinessDocument = "business_document";
export const VenueVerificationMethodInPerson = "in_person";
export const VenueVerificationMethodManualRelationship = "manual_relationship";
export type VenueVerificationMethod = typeof VenueVerificationMethodOfficialEmail | typeof VenueVerificationMethodOfficialSocial | typeof VenueVerificationMethodBusinessDocument | typeof VenueVerificationMethodInPerson | typeof VenueVerificationMethodManualRelationship;
export const VenueDealCategoryHappyHour = "happy_hour";
export const VenueDealCategoryFoodSpecial = "food_special";
export const VenueDealCategoryDrinkSpecial = "drink_special";
export const VenueDealCategoryLimitedTime = "limited_time";
export const VenueDealCategoryOther = "other";
export type VenueDealCategory = typeof VenueDealCategoryHappyHour | typeof VenueDealCategoryFoodSpecial | typeof VenueDealCategoryDrinkSpecial | typeof VenueDealCategoryLimitedTime | typeof VenueDealCategoryOther;
export const VenueDealStatusActive = "active";
export const VenueDealStatusPaused = "paused";
export const VenueDealStatusArchived = "archived";
export type VenueDealStatus = typeof VenueDealStatusActive | typeof VenueDealStatusPaused | typeof VenueDealStatusArchived;
export const VenueFixtureStatusActive = "active";
export const VenueFixtureStatusPaused = "paused";
export const VenueFixtureStatusArchived = "archived";
export type VenueFixtureStatus = typeof VenueFixtureStatusActive | typeof VenueFixtureStatusPaused | typeof VenueFixtureStatusArchived;
export const SubscriptionPlanFree = "free";
export const SubscriptionPlanPulse = "pulse";
export const SubscriptionPlanVenue = "venue";
export const SubscriptionPlanPro = "pro";
export type SubscriptionPlan = typeof SubscriptionPlanFree | typeof SubscriptionPlanPulse | typeof SubscriptionPlanVenue | typeof SubscriptionPlanPro;
export const OrganizationBillingPlanFree = "free";
export const OrganizationBillingPlanStarter = "starter";
export const OrganizationBillingPlanGrowth = "growth";
export const OrganizationBillingPlanPro = "pro";
export type OrganizationBillingPlan = typeof OrganizationBillingPlanFree | typeof OrganizationBillingPlanStarter | typeof OrganizationBillingPlanGrowth | typeof OrganizationBillingPlanPro;
export const OrganizationBillingStatusFree = "free";
export const OrganizationBillingStatusTrialing = "trialing";
export const OrganizationBillingStatusActive = "active";
export const OrganizationBillingStatusPastDue = "past_due";
export const OrganizationBillingStatusCanceled = "canceled";
export const OrganizationBillingStatusIncomplete = "incomplete";
export const OrganizationBillingStatusUnpaid = "unpaid";
export type OrganizationBillingStatus = typeof OrganizationBillingStatusFree | typeof OrganizationBillingStatusTrialing | typeof OrganizationBillingStatusActive | typeof OrganizationBillingStatusPastDue | typeof OrganizationBillingStatusCanceled | typeof OrganizationBillingStatusIncomplete | typeof OrganizationBillingStatusUnpaid;
export const OrganizationPlanFeatureEventPublishing = "event_publishing";
export const OrganizationPlanFeatureVenueProfile = "venue_profile";
export const OrganizationPlanFeatureBasicAnalytics = "basic_analytics";
export const OrganizationPlanFeatureTeamAccess = "team_access";
export const OrganizationPlanFeatureEventDuplication = "event_duplication";
export const OrganizationPlanFeatureBoostCredits = "boost_credits";
export const OrganizationPlanFeatureWeeklySummary = "weekly_summary";
export const OrganizationPlanFeatureTimingInsights = "timing_insights";
export const OrganizationPlanFeatureFollowerGrowth = "follower_growth";
export const OrganizationPlanFeatureRecurringAnalytics = "recurring_analytics";
export const OrganizationPlanFeaturePeakHours = "peak_hours";
export const OrganizationPlanFeatureAdvancedAnalytics = "advanced_analytics";
export const OrganizationPlanFeatureFixtureSlotPerformance = "fixture_slot_performance";
export const OrganizationPlanFeaturePriorityMapPlacement = "priority_map_placement";
export const OrganizationPlanFeatureAIFlyerExtraction = "ai_flyer_extraction";
export const OrganizationPlanFeatureVenueAnnouncements = "venue_announcements";
export const OrganizationPlanFeatureCompTickets = "comp_tickets";
export const OrganizationPlanFeatureReportExports = "report_exports";
export const OrganizationPlanFeatureRevenueAnalytics = "revenue_analytics";
export const OrganizationPlanFeatureWhiteGloveSupport = "white_glove_support";
export type OrganizationPlanFeature = typeof OrganizationPlanFeatureEventPublishing | typeof OrganizationPlanFeatureVenueProfile | typeof OrganizationPlanFeatureBasicAnalytics | typeof OrganizationPlanFeatureTeamAccess | typeof OrganizationPlanFeatureEventDuplication | typeof OrganizationPlanFeatureBoostCredits | typeof OrganizationPlanFeatureWeeklySummary | typeof OrganizationPlanFeatureTimingInsights | typeof OrganizationPlanFeatureFollowerGrowth | typeof OrganizationPlanFeatureRecurringAnalytics | typeof OrganizationPlanFeaturePeakHours | typeof OrganizationPlanFeatureAdvancedAnalytics | typeof OrganizationPlanFeatureFixtureSlotPerformance | typeof OrganizationPlanFeaturePriorityMapPlacement | typeof OrganizationPlanFeatureAIFlyerExtraction | typeof OrganizationPlanFeatureVenueAnnouncements | typeof OrganizationPlanFeatureCompTickets | typeof OrganizationPlanFeatureReportExports | typeof OrganizationPlanFeatureRevenueAnalytics | typeof OrganizationPlanFeatureWhiteGloveSupport;
export const BoostProductSpark = "spark";
export const BoostProductIgnite = "ignite";
export const BoostProductBlaze = "blaze";
export type BoostProduct = typeof BoostProductSpark | typeof BoostProductIgnite | typeof BoostProductBlaze;
export const BoostTierSpark = "spark";
export const BoostTierIgnite = "ignite";
export const BoostTierBlaze = "blaze";
export type BoostTier = typeof BoostTierSpark | typeof BoostTierIgnite | typeof BoostTierBlaze;
export const BoostPriceSpark = 1500;
export const BoostPriceIgnite = 3500;
export const BoostPriceBlaze = 6500;
export type BoostPrice = typeof BoostPriceSpark | typeof BoostPriceIgnite | typeof BoostPriceBlaze;
export const BoostScoreMultiplierSpark = 1.35;
export const BoostScoreMultiplierIgnite = 1.75;
export const BoostScoreMultiplierBlaze = 2.25;
export type BoostScoreMultiplier = typeof BoostScoreMultiplierSpark | typeof BoostScoreMultiplierIgnite | typeof BoostScoreMultiplierBlaze;
export const BoostFloorLiftSpark = 2.0;
export const BoostFloorLiftIgnite = 4.0;
export const BoostFloorLiftBlaze = 7.0;
export type BoostFloorLift = typeof BoostFloorLiftSpark | typeof BoostFloorLiftIgnite | typeof BoostFloorLiftBlaze;
export const BoostDurationSpark = 86400000000000;
export const BoostDurationIgnite = 259200000000000;
export const BoostDurationBlaze = 432000000000000;
export type BoostDuration = typeof BoostDurationSpark | typeof BoostDurationIgnite | typeof BoostDurationBlaze;
export const BoostAllowanceStarter = 1500;
export const BoostAllowanceGrowth = 3500;
export const BoostAllowancePro = 8000;
export type BoostAllowance = typeof BoostAllowanceStarter | typeof BoostAllowanceGrowth | typeof BoostAllowancePro;
export const BoostStatusPending = "pending";
export const BoostStatusActive = "active";
export const BoostStatusEnded = "ended";
export const BoostStatusCancelled = "cancelled";
export const BoostStatusFailed = "failed";
export type BoostStatus = typeof BoostStatusPending | typeof BoostStatusActive | typeof BoostStatusEnded | typeof BoostStatusCancelled | typeof BoostStatusFailed;
export const BoostPaymentStatusPending = "pending";
export const BoostPaymentStatusPaid = "paid";
export const BoostPaymentStatusFailed = "failed";
export const BoostPaymentStatusRefunded = "refunded";
export type BoostPaymentStatus = typeof BoostPaymentStatusPending | typeof BoostPaymentStatusPaid | typeof BoostPaymentStatusFailed | typeof BoostPaymentStatusRefunded;
export type BoostLedgerEntryType = string;
export const BoostLedgerGrant: BoostLedgerEntryType = "allowance_grant";
export const BoostLedgerConsumed: BoostLedgerEntryType = "allowance_consumed";
export const BoostLedgerAdjust: BoostLedgerEntryType = "manual_adjustment";
export interface OrganizationMembershipVenue {
  venue_id: string;
  venue_name: string;
  venue_slug?: string;
  subscription_plan: SubscriptionPlan;
}
export interface EventTagCatalogItem {
  slug: string;
  label: string;
  color?: string;
  text_color?: string;
  icon?: string;
  category_group: EventTagCategoryGroup;
  sort_order: number /* int32 */;
}
export interface EventTagCatalogGroup {
  category_group: EventTagCategoryGroup;
  label: string;
  tags: EventTagCatalogItem[];
}
export interface EventTagCatalogListResponse {
  groups: EventTagCatalogGroup[];
}
export interface EventAttributeCatalogItem {
  slug: string;
  label: string;
  icon?: string;
  sort_order: number /* int32 */;
}
export interface EventAttributeListResponse {
  attributes: EventAttributeCatalogItem[];
}
export interface MarketActivityPocket {
  id: string;
  slug: string;
  name: string;
  center_lat: number /* float64 */;
  center_lng: number /* float64 */;
  radius_meters: number /* int32 */;
}
export interface MarketActivityPocketListResponse {
  pockets: MarketActivityPocket[];
}
export interface OrganizationMembership {
  organization_id: string;
  organization_name: string;
  organization_slug: string;
  role: OrgRole;
  scope_all_venues: boolean;
  venues: OrganizationMembershipVenue[];
}
export interface MeMembershipsResult {
  memberships: OrganizationMembership[];
}
export interface OrganizationVenueSummary {
  venue_id: string;
  venue_name: string;
  venue_slug?: string;
  subscription_plan: SubscriptionPlan;
}
export interface OrganizationMemberVenueScope {
  venue_id: string;
  venue_name: string;
  venue_slug?: string;
}
export interface OrganizationDetail {
  id: string;
  name: string;
  slug: string;
  phone?: string;
  billing_email?: string;
  website_url?: string;
  viewer_role: OrgRole;
  viewer_scope_all_venues: boolean;
  created_at: string;
  venues: OrganizationVenueSummary[];
  feature_access: OrganizationFeatureAccess[];
}
export interface OrganizationBillingPlanOption {
  plan: OrganizationBillingPlan;
  label: string;
  price_label: string;
  tagline?: string;
  included_boost_credits: number /* int32 */;
  is_current: boolean;
  checkout_enabled: boolean;
}
export interface OrganizationFeatureAccess {
  feature: OrganizationPlanFeature;
  label: string;
  included: boolean;
  required_plan: OrganizationBillingPlan;
}
export interface OrganizationBillingSummary {
  organization_id: string;
  organization_name: string;
  billing_email?: string;
  billing_customer_id?: string;
  subscription_plan: OrganizationBillingPlan;
  billing_status: OrganizationBillingStatus;
  stripe_subscription_id?: string;
  subscription_current_period_end?: string | null;
  billing_grace_period_ends_at?: string | null;
  subscription_trial_ends_at?: string | null;
  subscription_cancel_at?: string | null;
  subscription_cancel_at_period_end: boolean;
  checkout_enabled: boolean;
  portal_enabled: boolean;
  plan_options: OrganizationBillingPlanOption[];
  feature_access: OrganizationFeatureAccess[];
}
export interface CreateOrganizationBillingCheckoutRequest {
  plan: OrganizationBillingPlan;
  success_url?: string;
  cancel_url?: string;
}
export interface CreateOrganizationBillingPortalRequest {
  return_url?: string;
}
export interface BillingSessionResult {
  url: string;
}
export interface CreateEventBoostRequest {
  tier: BoostTier;
}
export interface EventBoostState {
  id: string;
  tier: BoostTier;
  status: BoostStatus;
  payment_status: BoostPaymentStatus;
  starts_at?: string | null;
  ends_at?: string | null;
  can_upgrade: boolean;
  upgradeable_tiers?: BoostTier[];
}
export interface EventBoostROIMetrics {
  impressions: number /* int64 */;
  views: number /* int64 */;
  taps: number /* int64 */;
  saves: number /* int64 */;
  rsvps: number /* int64 */;
  tap_rate: number /* float64 */;
  save_rate: number /* float64 */;
  rsvp_rate: number /* float64 */;
  cost_per_tap_cents?: number | null;
  cost_per_rsvp_cents?: number | null;
}
export interface EventBoostROIResult {
  boost_id: string;
  event_id: string;
  tier: BoostTier;
  status: BoostStatus;
  starts_at: string;
  ends_at?: string | null;
  catalog_price_cents: number /* int32 */;
  allowance_applied_cents: number /* int32 */;
  direct_charge_cents: number /* int32 */;
  total_spend_cents: number /* int32 */;
  metrics: EventBoostROIMetrics;
  display_language: string;
}
export interface CreateEventBoostResult {
  checkout_url?: string | null;
  boost_id: string;
  allowance_applied_cents: number /* int32 */;
  direct_charge_cents: number /* int32 */;
  is_upgrade: boolean;
}
export interface OrganizationBoostAllowanceSummary {
  available_cents: number /* int32 */;
  plan_allowance_cents: number /* int32 */;
  used_cents: number /* int32 */;
  resets_at?: string | null;
}
export interface OrgActivityItem {
  id: string;
  type: OrgActivityEventType;
  organization_id: string;
  venue_id?: string | null;
  event_id?: string | null;
  actor_user_id?: string | null;
  actor_display_name: string;
  actor_role?: string;
  actor_kind: OrgActivityActorKind;
  entity_type?: string;
  entity_id?: string | null;
  entity_name?: string;
  changes: OrgActivityChange[];
  is_system_action: boolean;
  primary_text: string;
  secondary_text?: string;
  created_at: string;
}
export interface OrgActivityChange {
  field: string;
  old?: any;
  new?: any;
}
export interface OrgActivityListResult {
  activity: OrgActivityItem[];
}
export const OperatorRequiredSetupKindOrganization = "organization";
export const OperatorRequiredSetupKindVenue = "venue";
export type OperatorRequiredSetupKind = typeof OperatorRequiredSetupKindOrganization | typeof OperatorRequiredSetupKindVenue;
export interface OperatorPendingClaim {
  id: string;
  claim_type: VenueClaimType;
  venue_id?: string | null;
  venue_name: string;
  contact_email: string;
  contact_phone?: string;
  message?: string;
  claimant_role: VenueClaimRole;
  primary_contact_name?: string;
  primary_contact_email?: string;
  proposed_street_address?: string;
  proposed_city?: string;
  proposed_state?: string;
  proposed_website?: string;
  proposed_instagram_handle?: string;
  reviewer_note?: string;
  market_review_status?: VenueClaimMarketReviewStatus;
  created_at: string;
}
export interface OperatorOwnerHandoff {
  claim_id: string;
  venue_id: string;
  venue_name: string;
  primary_contact_email?: string;
  approved_at: string;
}
export interface OperatorRequiredSetup {
  kind: OperatorRequiredSetupKind;
  organization_id: string;
  organization_slug: string;
  organization_name: string;
  venue_id?: string | null;
  venue_name?: string | null;
}
export interface MeOperatorOnboardingResult {
  pending_claims: OperatorPendingClaim[];
  owner_handoff?: OperatorOwnerHandoff | null;
  required_setup?: OperatorRequiredSetup | null;
}
export interface OrganizationMemberSummary {
  user_id: string;
  email: string;
  username?: string;
  display_name?: string;
  role: OrgRole;
  scope_all_venues: boolean;
  venue_scopes?: OrganizationMemberVenueScope[];
  invited_at?: string;
  accepted_at?: string;
}
export interface OrganizationInvitationSummary {
  id: string;
  email: string;
  role: OrgRole;
  token: string;
  invited_by?: string;
  venues: OrganizationMemberVenueScope[];
  expires_at: string;
  created_at: string;
  accepted_at?: string;
}
export interface OrganizationInvitationPreview {
  organization_id: string;
  organization_name: string;
  invited_by?: string;
  email: string;
  role: OrgRole;
  token: string;
  venues: OrganizationMemberVenueScope[];
  accepted_at?: string;
  expires_at: string;
}
/**
 * PatchOrganizationMemberRequest is the request body for PATCH /organizations/{id}/members/{user_id}.
 */
export interface PatchOrganizationMemberRequest {
  role: OrgRole;
  venue_ids?: string[];
}
/**
 * EventStatus describes the event lifecycle state.
 */
export const EventStatusPending = "pending";
export const EventStatusActive = "active";
export const EventStatusRejected = "rejected";
export const EventStatusCancelled = "cancelled";
export const EventStatusArchived = "archived";
export type EventStatus = typeof EventStatusPending | typeof EventStatusActive | typeof EventStatusRejected | typeof EventStatusCancelled | typeof EventStatusArchived;
export const EventCurationDecisionAccept = "accept";
export const EventCurationDecisionReject = "reject";
export const EventCurationDecisionFlag = "flag";
export type EventCurationDecision = typeof EventCurationDecisionAccept | typeof EventCurationDecisionReject | typeof EventCurationDecisionFlag;
export const DiscordIntakeReviewStatusApproved = "approved";
export const DiscordIntakeReviewStatusReviewNeeded = "review_needed";
export const DiscordIntakeReviewStatusRejected = "rejected";
export type DiscordIntakeReviewStatus = typeof DiscordIntakeReviewStatusApproved | typeof DiscordIntakeReviewStatusReviewNeeded | typeof DiscordIntakeReviewStatusRejected;
export const DiscordIntakeVenueMatchStateUnknown = "unknown";
export const DiscordIntakeVenueMatchStateMatched = "matched";
export const DiscordIntakeVenueMatchStateNeedsMatch = "needs_match";
export type DiscordIntakeVenueMatchState = typeof DiscordIntakeVenueMatchStateUnknown | typeof DiscordIntakeVenueMatchStateMatched | typeof DiscordIntakeVenueMatchStateNeedsMatch;
export const EventMomentumNone = "none";
export const EventMomentumHot = "hot";
export const EventMomentumTrending = "trending";
export type EventMomentum = typeof EventMomentumNone | typeof EventMomentumHot | typeof EventMomentumTrending;
export const FeedTimeWindowAll = "all";
export const FeedTimeWindowNow = "now";
export const FeedTimeWindowToday = "today";
export const FeedTimeWindowTonight = "tonight";
export const FeedTimeWindowTomorrow = "tomorrow";
export const FeedTimeWindowWeekend = "weekend";
export const FeedTimeWindowWeek = "week";
export type FeedTimeWindow = typeof FeedTimeWindowAll | typeof FeedTimeWindowNow | typeof FeedTimeWindowToday | typeof FeedTimeWindowTonight | typeof FeedTimeWindowTomorrow | typeof FeedTimeWindowWeekend | typeof FeedTimeWindowWeek;
export const FeedModeProximity = "proximity";
export const FeedModeSmart = "smart";
export type FeedMode = typeof FeedModeProximity | typeof FeedModeSmart;
export type EventFeedbackType = string;
export const EventFeedbackTypeNotInterested: EventFeedbackType = "not_interested";
export const AnalyticsPropertyTypeBoolean = "boolean";
export const AnalyticsPropertyTypeNumber = "number";
export const AnalyticsPropertyTypeString = "string";
export type AnalyticsPropertyType = typeof AnalyticsPropertyTypeBoolean | typeof AnalyticsPropertyTypeNumber | typeof AnalyticsPropertyTypeString;
export type AnalyticsPlatform = string;
export const AnalyticsPlatformServer: AnalyticsPlatform = "server";
export const AnalyticsEventNameVenueProfileView = "venue_profile_view";
export const AnalyticsEventNameVenueSheetView = "venue_sheet_view";
export const AnalyticsEventNameVenueMapAppearance = "venue_map_appearance";
export const AnalyticsEventNameVenueMapTap = "venue_map_tap";
export const AnalyticsEventNameVenueSearchAppearance = "venue_search_appearance";
export const AnalyticsEventNameVenueSearchTap = "venue_search_tap";
export const AnalyticsEventNameVenueShare = "venue_share";
export const AnalyticsEventNameVenueDirectionsTapped = "venue_directions_tapped";
export const AnalyticsEventNameVenueWebsiteTapped = "venue_website_tapped";
export const AnalyticsEventNameVenueInstagramTapped = "venue_instagram_tapped";
export const AnalyticsEventNameVenueBookingTapped = "venue_booking_tapped";
export const AnalyticsEventNameVenueFollow = "venue_follow";
export const AnalyticsEventNameVenueUnfollow = "venue_unfollow";
export const AnalyticsEventNameEventView = "event_view";
export const AnalyticsEventNameEventImpression = "event_impression";
export const AnalyticsEventNameEventSearchAppearance = "event_search_appearance";
export const AnalyticsEventNameEventSearchTap = "event_search_tap";
export const AnalyticsEventNameEventMapAppearance = "event_map_appearance";
export const AnalyticsEventNameEventMapTap = "event_map_tap";
export const AnalyticsEventNameEventNotInterested = "event_not_interested";
export const AnalyticsEventNameEventSaved = "event_saved";
export const AnalyticsEventNameEventUnsaved = "event_unsaved";
export const AnalyticsEventNameRSVPConfirmed = "event_rsvp";
export const AnalyticsEventNameRSVPCancelled = "rsvp_cancelled";
export const AnalyticsEventNameEventShare = "event_share";
export const AnalyticsEventNameCalendarExportTapped = "calendar_export_tapped";
export const AnalyticsEventNameTicketLinkTapped = "ticket_link_tapped";
export const AnalyticsEventNameCommentSubmitted = "comment_submitted";
export const AnalyticsEventNameEventCreated = "event_created";
export const AnalyticsEventNameEventCancelled = "event_cancelled";
export const AnalyticsEventNameEventDeleted = "event_deleted";
export const AnalyticsEventNameDealImpression = "deal_impression";
export const AnalyticsEventNameDealView = "deal_view";
export const AnalyticsEventNameDealTap = "deal_tap";
export const AnalyticsEventNameDealSaved = "deal_saved";
export const AnalyticsEventNameDealUnsaved = "deal_unsaved";
export const AnalyticsEventNameDealShare = "deal_share";
export const AnalyticsEventNameDealDirectionsTapped = "deal_directions_tapped";
export const AnalyticsEventNameDealSearchAppearance = "deal_search_appearance";
export const AnalyticsEventNameDealSearchTap = "deal_search_tap";
export const AnalyticsEventNameDealMapAppearance = "deal_map_appearance";
export const AnalyticsEventNameDealMapTap = "deal_map_tap";
export const AnalyticsEventNameFixtureEventView = "fixture_event_view";
export const AnalyticsEventNameFixtureEventRSVP = "fixture_event_rsvp";
export const AnalyticsEventNameFixtureDealView = "fixture_deal_view";
export const AnalyticsEventNameFixtureSlotImpression = "fixture_slot_impression";
export const AnalyticsEventNameSearchQuery = "search_query";
export const AnalyticsEventNameSearchResultTapped = "search_result_tapped";
export const AnalyticsEventNameScreenView = "screen_view";
export const AnalyticsEventNameMapOpened = "map_opened";
export const AnalyticsEventNameMapFilterApplied = "map_filter_applied";
export const AnalyticsEventNameFeedFilterApplied = "feed_filter_applied";
export const AnalyticsEventNamePushNotificationOpened = "push_notification_opened";
export const AnalyticsEventNameLandingPageView = "landing_page_view";
export const AnalyticsEventNameLandingCTAClicked = "landing_cta_clicked";
export const AnalyticsEventNameQRScan = "qr_scan";
export const AnalyticsEventNameLocationPermissionGranted = "location_permission_granted";
export const AnalyticsEventNameLocationPermissionDenied = "location_permission_denied";
export const AnalyticsEventNameNotificationPermissionGranted = "notification_permission_granted";
export const AnalyticsEventNameNotificationPermissionDenied = "notification_permission_denied";
export const AnalyticsEventNameReportSubmitted = "report_submitted";
export const AnalyticsEventNameWorkspaceContextSwitched = "workspace_context_switched";
export const AnalyticsEventNameBusinessActionTapped = "business_action_tapped";
export const AnalyticsEventNameBusinessNotificationAction = "business_notification_action";
export const AnalyticsEventNameBusinessDealAction = "business_deal_action";
export const AnalyticsEventNameCreateEventOpen = "create_event_open";
export const AnalyticsEventNameEditEventOpen = "edit_event_open";
export const AnalyticsEventNameFlyerManualOverride = "flyer_manual_override";
export const AnalyticsEventNameFlyerImportStarted = "flyer_import_started";
export const AnalyticsEventNameFlyerImportSucceeded = "flyer_import_succeeded";
export const AnalyticsEventNameFlyerDuplicateDetected = "flyer_duplicate_detected";
export const AnalyticsEventNameFlyerImportFailed = "flyer_import_failed";
export const AnalyticsEventNameFlyerDraftCleared = "flyer_draft_cleared";
export type AnalyticsEventName = typeof AnalyticsEventNameVenueProfileView | typeof AnalyticsEventNameVenueSheetView | typeof AnalyticsEventNameVenueMapAppearance | typeof AnalyticsEventNameVenueMapTap | typeof AnalyticsEventNameVenueSearchAppearance | typeof AnalyticsEventNameVenueSearchTap | typeof AnalyticsEventNameVenueShare | typeof AnalyticsEventNameVenueDirectionsTapped | typeof AnalyticsEventNameVenueWebsiteTapped | typeof AnalyticsEventNameVenueInstagramTapped | typeof AnalyticsEventNameVenueBookingTapped | typeof AnalyticsEventNameVenueFollow | typeof AnalyticsEventNameVenueUnfollow | typeof AnalyticsEventNameEventView | typeof AnalyticsEventNameEventImpression | typeof AnalyticsEventNameEventSearchAppearance | typeof AnalyticsEventNameEventSearchTap | typeof AnalyticsEventNameEventMapAppearance | typeof AnalyticsEventNameEventMapTap | typeof AnalyticsEventNameEventNotInterested | typeof AnalyticsEventNameEventSaved | typeof AnalyticsEventNameEventUnsaved | typeof AnalyticsEventNameRSVPConfirmed | typeof AnalyticsEventNameRSVPCancelled | typeof AnalyticsEventNameEventShare | typeof AnalyticsEventNameCalendarExportTapped | typeof AnalyticsEventNameTicketLinkTapped | typeof AnalyticsEventNameCommentSubmitted | typeof AnalyticsEventNameEventCreated | typeof AnalyticsEventNameEventCancelled | typeof AnalyticsEventNameEventDeleted | typeof AnalyticsEventNameDealImpression | typeof AnalyticsEventNameDealView | typeof AnalyticsEventNameDealTap | typeof AnalyticsEventNameDealSaved | typeof AnalyticsEventNameDealUnsaved | typeof AnalyticsEventNameDealShare | typeof AnalyticsEventNameDealDirectionsTapped | typeof AnalyticsEventNameDealSearchAppearance | typeof AnalyticsEventNameDealSearchTap | typeof AnalyticsEventNameDealMapAppearance | typeof AnalyticsEventNameDealMapTap | typeof AnalyticsEventNameFixtureEventView | typeof AnalyticsEventNameFixtureEventRSVP | typeof AnalyticsEventNameFixtureDealView | typeof AnalyticsEventNameFixtureSlotImpression | typeof AnalyticsEventNameSearchQuery | typeof AnalyticsEventNameSearchResultTapped | typeof AnalyticsEventNameScreenView | typeof AnalyticsEventNameMapOpened | typeof AnalyticsEventNameMapFilterApplied | typeof AnalyticsEventNameFeedFilterApplied | typeof AnalyticsEventNamePushNotificationOpened | typeof AnalyticsEventNameLandingPageView | typeof AnalyticsEventNameLandingCTAClicked | typeof AnalyticsEventNameQRScan | typeof AnalyticsEventNameLocationPermissionGranted | typeof AnalyticsEventNameLocationPermissionDenied | typeof AnalyticsEventNameNotificationPermissionGranted | typeof AnalyticsEventNameNotificationPermissionDenied | typeof AnalyticsEventNameReportSubmitted | typeof AnalyticsEventNameWorkspaceContextSwitched | typeof AnalyticsEventNameBusinessActionTapped | typeof AnalyticsEventNameBusinessNotificationAction | typeof AnalyticsEventNameBusinessDealAction | typeof AnalyticsEventNameCreateEventOpen | typeof AnalyticsEventNameEditEventOpen | typeof AnalyticsEventNameFlyerManualOverride | typeof AnalyticsEventNameFlyerImportStarted | typeof AnalyticsEventNameFlyerImportSucceeded | typeof AnalyticsEventNameFlyerDuplicateDetected | typeof AnalyticsEventNameFlyerImportFailed | typeof AnalyticsEventNameFlyerDraftCleared;
export type AnalyticsGroupType = string;
export const AnalyticsGroupTypeVenue: AnalyticsGroupType = "venue";
export const AnalyticsSourceFeed = "feed";
export const AnalyticsSourceMap = "map";
export const AnalyticsSourceSearch = "search";
export const AnalyticsSourceVenuePage = "venue_page";
export const AnalyticsSourceEventDetail = "event_detail";
export const AnalyticsSourceProfile = "profile";
export const AnalyticsSourcePush = "push";
export const AnalyticsSourceShareLink = "share_link";
export const AnalyticsSourceBackstagePreview = "backstage_preview";
export const AnalyticsSourceAccountContext = "account_context_sheet";
export const AnalyticsSourceBusinessInbox = "business_inbox";
export const AnalyticsSourceBusinessDeals = "business_deals";
export const AnalyticsSourceUnknown = "unknown";
export type AnalyticsSource = typeof AnalyticsSourceFeed | typeof AnalyticsSourceMap | typeof AnalyticsSourceSearch | typeof AnalyticsSourceVenuePage | typeof AnalyticsSourceEventDetail | typeof AnalyticsSourceProfile | typeof AnalyticsSourcePush | typeof AnalyticsSourceShareLink | typeof AnalyticsSourceBackstagePreview | typeof AnalyticsSourceAccountContext | typeof AnalyticsSourceBusinessInbox | typeof AnalyticsSourceBusinessDeals | typeof AnalyticsSourceUnknown;
export const AnalyticsSurfaceMobile = "mobile";
export const AnalyticsSurfaceMobileMapSheet = "mobile_map_sheet";
export const AnalyticsSurfaceMobileVenuePage = "mobile_venue_page";
export const AnalyticsSurfaceMobileEventDetail = "mobile_event_detail";
export const AnalyticsSurfaceMobileSearch = "mobile_search";
export const AnalyticsSurfaceMobileFeed = "mobile_feed";
export const AnalyticsSurfaceMobileBusiness = "mobile_business";
export const AnalyticsSurfaceMobileBusinessInbox = "mobile_business_inbox";
export const AnalyticsSurfaceWeb = "web";
export const AnalyticsSurfaceLandingSite = "landing_site";
export const AnalyticsSurfaceBackstage = "backstage";
export const AnalyticsSurfaceStudio = "studio";
export const AnalyticsSurfaceServer = "server";
export type AnalyticsSurface = typeof AnalyticsSurfaceMobile | typeof AnalyticsSurfaceMobileMapSheet | typeof AnalyticsSurfaceMobileVenuePage | typeof AnalyticsSurfaceMobileEventDetail | typeof AnalyticsSurfaceMobileSearch | typeof AnalyticsSurfaceMobileFeed | typeof AnalyticsSurfaceMobileBusiness | typeof AnalyticsSurfaceMobileBusinessInbox | typeof AnalyticsSurfaceWeb | typeof AnalyticsSurfaceLandingSite | typeof AnalyticsSurfaceBackstage | typeof AnalyticsSurfaceStudio | typeof AnalyticsSurfaceServer;
export const AnalyticsMetricProfileViews = "profile_views";
export const AnalyticsMetricVenueSheetViews = "venue_sheet_views";
export const AnalyticsMetricMapAppearances = "map_appearances";
export const AnalyticsMetricSearchAppearances = "search_appearances";
export const AnalyticsMetricEventViews = "event_views";
export const AnalyticsMetricEventImpressions = "event_impressions";
export const AnalyticsMetricDealViews = "deal_views";
export const AnalyticsMetricDealImpressions = "deal_impressions";
export const AnalyticsMetricDirectionsTaps = "directions_taps";
export const AnalyticsMetricShares = "shares";
export const AnalyticsMetricSaves = "saves";
export const AnalyticsMetricRSVPs = "rsvps";
export const AnalyticsMetricComments = "comments";
export const AnalyticsMetricFollows = "follows";
export const AnalyticsMetricWebsiteTaps = "website_taps";
export const AnalyticsMetricTicketTaps = "ticket_taps";
export type AnalyticsMetric = typeof AnalyticsMetricProfileViews | typeof AnalyticsMetricVenueSheetViews | typeof AnalyticsMetricMapAppearances | typeof AnalyticsMetricSearchAppearances | typeof AnalyticsMetricEventViews | typeof AnalyticsMetricEventImpressions | typeof AnalyticsMetricDealViews | typeof AnalyticsMetricDealImpressions | typeof AnalyticsMetricDirectionsTaps | typeof AnalyticsMetricShares | typeof AnalyticsMetricSaves | typeof AnalyticsMetricRSVPs | typeof AnalyticsMetricComments | typeof AnalyticsMetricFollows | typeof AnalyticsMetricWebsiteTaps | typeof AnalyticsMetricTicketTaps;
export const RsvpSourceFeed = "feed";
export const RsvpSourceDetail = "detail";
export const RsvpSourceMap = "map";
export type RsvpSource = typeof RsvpSourceFeed | typeof RsvpSourceDetail | typeof RsvpSourceMap;
/**
 * UserSummary is the authenticated account summary exposed to clients.
 */
export interface UserSummary {
  id: string;
  email: string;
  has_password: boolean;
  created_at: string;
}
/**
 * ProfileSummary is the public profile information shared across responses.
 */
export interface ProfileSummary {
  user_id: string;
  username: string;
  display_name: string;
  bio: string;
  avatar_url: string;
  is_public: boolean;
  visibility: ProfileVisibility;
  is_limited: boolean;
  is_staff: boolean;
  is_venue: boolean;
  venue_id?: string | null;
  venue_name: string;
  interest_tags: string[];
}
/**
 * MarketAccess identifies the viewer's market access mode.
 */
export const MarketAccessSupported = "supported";
export const MarketAccessVisiting = "visiting";
export const MarketAccessReadOnly = "read_only";
export type MarketAccess = typeof MarketAccessSupported | typeof MarketAccessVisiting | typeof MarketAccessReadOnly;
export type BrowseOriginSource = string;
export const BrowseOriginSourceMarket: BrowseOriginSource = "market";
export interface BrowseOrigin {
  latitude: number /* float64 */;
  longitude: number /* float64 */;
  market_name: string;
  source: BrowseOriginSource;
}
/**
 * AuthProfile is the authenticated profile information shared across private responses.
 */
export interface AuthProfile {
  user_id: string;
  username: string;
  display_name: string;
  bio: string;
  avatar_url: string;
  is_public: boolean;
  visibility: ProfileVisibility;
  is_staff: boolean;
  is_venue: boolean;
  venue_id?: string | null;
  venue_name: string;
  visiting: boolean;
  home_city?: string | null;
  last_county_name?: string | null;
  last_latitude?: number | null;
  last_longitude?: number | null;
  last_location_at?: string | null;
  location_tracking_enabled: boolean;
  market_access: MarketAccess;
  browse_origin?: BrowseOrigin | null;
  interest_tags: string[];
}
/**
 * VenueSummary is the compact venue result used in global search.
 */
export interface VenueSummary {
  id: string;
  name: string;
  address?: string;
  lat?: number /* float64 */;
  lng?: number /* float64 */;
  category?: string;
  is_verified: boolean;
  logo_url?: string;
  claimed: boolean;
}
export interface VenueSocialLink {
  platform: VenueSocialPlatform;
  url: string;
}
export interface VenueHour {
  day: VenueWeekday;
  closed: boolean;
  opens_at?: string | null;
  closes_at?: string | null;
}
export interface VenueDetail {
  id: string;
  name: string;
  slug?: string;
  address?: string;
  city: string;
  state: string;
  zip?: string;
  lat?: number /* float64 */;
  lng?: number /* float64 */;
  phone?: string;
  website?: string;
  booking_url?: string;
  email?: string;
  instagram_handle?: string;
  category?: string;
  description?: string;
  google_place_id?: string;
  is_verified: boolean;
  logo_url?: string;
  cover_url?: string;
  logo_focal_point_x: number /* float64 */;
  logo_focal_point_y: number /* float64 */;
  logo_focal_scale: number /* float64 */;
  cover_focal_point_x: number /* float64 */;
  cover_focal_point_y: number /* float64 */;
  cover_focal_scale: number /* float64 */;
  claimed: boolean;
  claimed_by_username?: string;
  event_count: number /* int */;
  follower_count: number /* int64 */;
  viewer_is_owner: boolean;
  age_restriction: EventAgeRestriction;
  tags: string[];
  social_links: VenueSocialLink[];
  hours: VenueHour[];
  deals: VenuePublicDeal[];
}
export interface VenueWeeklyStats {
  views: number /* int64 */;
  rsvps: number /* int64 */;
  followers: number /* int64 */;
}
export interface VenueOwnerEventSummary {
  id: string;
  title: string;
  starts_at: string;
  ends_at?: string | null;
  views: number /* int64 */;
  rsvps: number /* int64 */;
  source_fixture_id?: string | null;
  is_fixture_managed: boolean;
}
export interface VenueOwnerOverview {
  stats: VenueWeeklyStats;
  upcoming_events: VenueOwnerEventSummary[];
  past_events: VenueOwnerEventSummary[];
}
export interface VenueAnalyticsTotals {
  reach: number /* int64 */;
  profile_views: number /* int64 */;
  event_views: number /* int64 */;
  event_impressions: number /* int64 */;
  deal_views: number /* int64 */;
  deal_impressions: number /* int64 */;
  deal_engagement: number /* int64 */;
  map_appearances: number /* int64 */;
  search_appearances: number /* int64 */;
  direction_taps: number /* int64 */;
  shares: number /* int64 */;
  saves: number /* int64 */;
  rsvps: number /* int64 */;
  comments: number /* int64 */;
  followers: number /* int64 */;
  follower_growth: number /* int64 */;
}
export interface VenueAnalyticsTimelinePoint {
  date: string;
  profile_views: number /* int64 */;
  event_views: number /* int64 */;
  event_impressions: number /* int64 */;
  deal_views: number /* int64 */;
  deal_impressions: number /* int64 */;
  deal_engagement: number /* int64 */;
  map_appearances: number /* int64 */;
  search_appearances: number /* int64 */;
  direction_taps: number /* int64 */;
  shares: number /* int64 */;
  saves: number /* int64 */;
  rsvps: number /* int64 */;
  comments: number /* int64 */;
}
export interface VenueAnalyticsSourceBreakdown {
  source: string;
  count: number /* int64 */;
}
export interface VenueAnalyticsEventPerformance {
  id: string;
  title: string;
  starts_at?: string | null;
  poster_url?: string;
  views: number /* int64 */;
  impressions: number /* int64 */;
  saves: number /* int64 */;
  rsvps: number /* int64 */;
  shares: number /* int64 */;
  direction_taps: number /* int64 */;
}
export interface VenueAnalyticsDealPerformance {
  id: string;
  title: string;
  category: string;
  views: number /* int64 */;
  impressions: number /* int64 */;
  saves: number /* int64 */;
  shares: number /* int64 */;
  direction_taps: number /* int64 */;
}
export interface VenueAnalyticsSummary {
  lines: string[];
  top_event: string;
  top_deal: string;
  top_source: string;
}
export const VenueAnalyticsTimingSlotMorning = "morning";
export const VenueAnalyticsTimingSlotAfternoon = "afternoon";
export const VenueAnalyticsTimingSlotEvening = "evening";
export const VenueAnalyticsTimingSlotLateNight = "late_night";
export type VenueAnalyticsTimingSlot = typeof VenueAnalyticsTimingSlotMorning | typeof VenueAnalyticsTimingSlotAfternoon | typeof VenueAnalyticsTimingSlotEvening | typeof VenueAnalyticsTimingSlotLateNight;
export const VenueAnalyticsTimingConfidenceSparse = "sparse";
export const VenueAnalyticsTimingConfidenceEmerging = "emerging";
export const VenueAnalyticsTimingConfidenceReliable = "reliable";
export type VenueAnalyticsTimingConfidence = typeof VenueAnalyticsTimingConfidenceSparse | typeof VenueAnalyticsTimingConfidenceEmerging | typeof VenueAnalyticsTimingConfidenceReliable;
export interface VenueAnalyticsTimingInsight {
  weekday: VenueWeekday;
  slot: VenueAnalyticsTimingSlot;
  hour_start: number /* int32 */;
  label: string;
  event_count: number /* int64 */;
  engagement_score: number /* int64 */;
  views: number /* int64 */;
  impressions: number /* int64 */;
  saves: number /* int64 */;
  rsvps: number /* int64 */;
  shares: number /* int64 */;
  direction_taps: number /* int64 */;
  confidence: VenueAnalyticsTimingConfidence;
  summary: string;
  next_move: string;
}
export interface VenueAnalyticsPeakHour {
  weekday: VenueWeekday;
  hour: number /* int32 */;
  reach: number /* int64 */;
  views: number /* int64 */;
  actions: number /* int64 */;
  activity_score: number /* int64 */;
  confidence: VenueAnalyticsTimingConfidence;
}
export const VenueAnalyticsTrendWindow30d = "30d";
export const VenueAnalyticsTrendWindow60d = "60d";
export const VenueAnalyticsTrendWindow90d = "90d";
export type VenueAnalyticsTrendWindow = typeof VenueAnalyticsTrendWindow30d | typeof VenueAnalyticsTrendWindow60d | typeof VenueAnalyticsTrendWindow90d;
export const VenueAnalyticsTrendSeriesStateAvailable = "available";
export const VenueAnalyticsTrendSeriesStateSparse = "sparse";
export const VenueAnalyticsTrendSeriesStateUnavailable = "unavailable";
export type VenueAnalyticsTrendSeriesState = typeof VenueAnalyticsTrendSeriesStateAvailable | typeof VenueAnalyticsTrendSeriesStateSparse | typeof VenueAnalyticsTrendSeriesStateUnavailable;
export interface VenueAnalyticsTrendPoint {
  date: string;
  views: number /* int64 */;
  rsvps: number /* int64 */;
  direction_taps: number /* int64 */;
  shares: number /* int64 */;
}
export interface VenueAnalyticsTrendTotals {
  views: number /* int64 */;
  rsvps: number /* int64 */;
  direction_taps: number /* int64 */;
  shares: number /* int64 */;
}
export interface VenueAnalyticsTrendSeries {
  totals: VenueAnalyticsTrendTotals;
  points: VenueAnalyticsTrendPoint[];
}
export interface VenueAnalyticsTrendEventOption {
  id: string;
  title: string;
  starts_at?: string | null;
  ends_at?: string | null;
  poster_url?: string;
  active_days: number /* int64 */;
}
export const VenueAnalyticsEventSourceStateAvailable = "available";
export const VenueAnalyticsEventSourceStateSparse = "sparse";
export const VenueAnalyticsEventSourceStateUnavailable = "unavailable";
export type VenueAnalyticsEventSourceState = typeof VenueAnalyticsEventSourceStateAvailable | typeof VenueAnalyticsEventSourceStateSparse | typeof VenueAnalyticsEventSourceStateUnavailable;
export const VenueAnalyticsComparisonStateAvailable = "available";
export const VenueAnalyticsComparisonStateSparse = "sparse";
export const VenueAnalyticsComparisonStateUnavailable = "unavailable";
export type VenueAnalyticsComparisonState = typeof VenueAnalyticsComparisonStateAvailable | typeof VenueAnalyticsComparisonStateSparse | typeof VenueAnalyticsComparisonStateUnavailable;
export const VenueAnalyticsComparisonWinnerLeft = "left";
export const VenueAnalyticsComparisonWinnerRight = "right";
export const VenueAnalyticsComparisonWinnerTie = "tie";
export type VenueAnalyticsComparisonWinner = typeof VenueAnalyticsComparisonWinnerLeft | typeof VenueAnalyticsComparisonWinnerRight | typeof VenueAnalyticsComparisonWinnerTie;
export const VenueAnalyticsComparisonMetricKeyViews = "views";
export const VenueAnalyticsComparisonMetricKeyImpressions = "impressions";
export const VenueAnalyticsComparisonMetricKeySaves = "saves";
export const VenueAnalyticsComparisonMetricKeyRSVPs = "rsvps";
export const VenueAnalyticsComparisonMetricKeyShares = "shares";
export const VenueAnalyticsComparisonMetricKeyDirectionTaps = "direction_taps";
export type VenueAnalyticsComparisonMetricKey = typeof VenueAnalyticsComparisonMetricKeyViews | typeof VenueAnalyticsComparisonMetricKeyImpressions | typeof VenueAnalyticsComparisonMetricKeySaves | typeof VenueAnalyticsComparisonMetricKeyRSVPs | typeof VenueAnalyticsComparisonMetricKeyShares | typeof VenueAnalyticsComparisonMetricKeyDirectionTaps;
export interface VenueAnalyticsComparisonTotals {
  views: number /* int64 */;
  impressions: number /* int64 */;
  saves: number /* int64 */;
  rsvps: number /* int64 */;
  shares: number /* int64 */;
  direction_taps: number /* int64 */;
}
export interface VenueAnalyticsComparisonEvent {
  id: string;
  title: string;
  starts_at?: string | null;
  active_days: number /* int64 */;
  totals: VenueAnalyticsComparisonTotals;
}
export interface VenueAnalyticsComparisonMetric {
  key: VenueAnalyticsComparisonMetricKey;
  left_value: number /* int64 */;
  right_value: number /* int64 */;
  difference: number /* int64 */;
  winner: VenueAnalyticsComparisonWinner;
}
export const VenueAnalyticsRecurringItemKindHappyHour = "happy_hour";
export const VenueAnalyticsRecurringItemKindFixture = "fixture";
export type VenueAnalyticsRecurringItemKind = typeof VenueAnalyticsRecurringItemKindHappyHour | typeof VenueAnalyticsRecurringItemKindFixture;
export const VenueAnalyticsRecurringItemStatusActive = "active";
export const VenueAnalyticsRecurringItemStatusPaused = "paused";
export const VenueAnalyticsRecurringItemStatusArchived = "archived";
export type VenueAnalyticsRecurringItemStatus = typeof VenueAnalyticsRecurringItemStatusActive | typeof VenueAnalyticsRecurringItemStatusPaused | typeof VenueAnalyticsRecurringItemStatusArchived;
export const VenueAnalyticsRecurringSlotStateAvailable = "available";
export const VenueAnalyticsRecurringSlotStateSparse = "sparse";
export const VenueAnalyticsRecurringSlotStateUnavailable = "unavailable";
export type VenueAnalyticsRecurringSlotState = typeof VenueAnalyticsRecurringSlotStateAvailable | typeof VenueAnalyticsRecurringSlotStateSparse | typeof VenueAnalyticsRecurringSlotStateUnavailable;
export const VenueAnalyticsRetentionStateAvailable = "available";
export const VenueAnalyticsRetentionStateSparse = "sparse";
export const VenueAnalyticsRetentionStateUnavailable = "unavailable";
export type VenueAnalyticsRetentionState = typeof VenueAnalyticsRetentionStateAvailable | typeof VenueAnalyticsRetentionStateSparse | typeof VenueAnalyticsRetentionStateUnavailable;
export const VenueAnalyticsFollowerGrowthStateAvailable = "available";
export const VenueAnalyticsFollowerGrowthStateSparse = "sparse";
export const VenueAnalyticsFollowerGrowthStateUnavailable = "unavailable";
export type VenueAnalyticsFollowerGrowthState = typeof VenueAnalyticsFollowerGrowthStateAvailable | typeof VenueAnalyticsFollowerGrowthStateSparse | typeof VenueAnalyticsFollowerGrowthStateUnavailable;
export interface VenueAnalyticsRecurringMetrics {
  views: number /* int64 */;
  impressions: number /* int64 */;
  saves: number /* int64 */;
  rsvps: number /* int64 */;
  shares: number /* int64 */;
  direction_taps: number /* int64 */;
}
export interface VenueAnalyticsRecurringItem {
  id: string;
  title: string;
  kind: VenueAnalyticsRecurringItemKind;
  status: VenueAnalyticsRecurringItemStatus;
  schedule_label: string;
  poster_url?: string;
  metrics: VenueAnalyticsRecurringMetrics;
}
export interface VenueAnalyticsFixtureSlotRanking {
  weekday: VenueWeekday;
  starts_at_local: string;
  ends_at_local: string;
  fixture_count: number /* int64 */;
  metrics: VenueAnalyticsRecurringMetrics;
}
export interface VenueAnalyticsRetentionPoint {
  week_start: string;
  week_end: string;
  unique_viewers: number /* int64 */;
  returning_viewers: number /* int64 */;
  new_viewers: number /* int64 */;
  repeat_rate: number /* int32 */;
}
export interface VenueAnalyticsFollowerGrowthPoint {
  week_start: string;
  week_end: string;
  new_followers: number /* int64 */;
  total_followers: number /* int64 */;
  previous_followers: number /* int64 */;
}
export const VenueWeeklyDigestSectionKindOverview = "overview";
export const VenueWeeklyDigestSectionKindWorked = "worked";
export const VenueWeeklyDigestSectionKindGuestIntent = "guest_intent";
export const VenueWeeklyDigestSectionKindNextMove = "next_move";
export type VenueWeeklyDigestSectionKind = typeof VenueWeeklyDigestSectionKindOverview | typeof VenueWeeklyDigestSectionKindWorked | typeof VenueWeeklyDigestSectionKindGuestIntent | typeof VenueWeeklyDigestSectionKindNextMove;
export interface VenueWeeklyDigestMetric {
  label: string;
  value: string;
  detail: string;
}
export interface VenueWeeklyDigestSection {
  kind: VenueWeeklyDigestSectionKind;
  title: string;
  body: string;
  metrics: VenueWeeklyDigestMetric[];
}
export interface VenueWeeklyPerformanceDigest {
  venue_name: string;
  range_start: string;
  range_end: string;
  subject: string;
  preview_text: string;
  sections: VenueWeeklyDigestSection[];
  footer_note: string;
}
export interface VenueAnalyticsOverview {
  range_start: string;
  range_end: string;
  totals: VenueAnalyticsTotals;
  timeline: VenueAnalyticsTimelinePoint[];
  sources: VenueAnalyticsSourceBreakdown[];
  top_events: VenueAnalyticsEventPerformance[];
  top_deals: VenueAnalyticsDealPerformance[];
  timing_insights: VenueAnalyticsTimingInsight[];
  peak_hours: VenueAnalyticsPeakHour[];
  summary: VenueAnalyticsSummary;
}
export interface VenueAnalyticsEventsResult {
  events: VenueAnalyticsEventPerformance[];
}
export interface VenueAnalyticsDealsResult {
  deals: VenueAnalyticsDealPerformance[];
}
export interface VenueAnalyticsTimelineResult {
  timeline: VenueAnalyticsTimelinePoint[];
}
export interface VenueAnalyticsTrendsResult {
  window: VenueAnalyticsTrendWindow;
  range_start: string;
  range_end: string;
  venue_series: VenueAnalyticsTrendSeries;
  eligible_events: VenueAnalyticsTrendEventOption[];
  selected_event_id?: string | null;
  event_series?: VenueAnalyticsTrendSeries;
  event_series_state: VenueAnalyticsTrendSeriesState;
  event_series_message?: string;
}
export interface VenueAnalyticsEventSourcesResult {
  eligible_events: VenueAnalyticsTrendEventOption[];
  selected_event_id?: string | null;
  sources: VenueAnalyticsSourceBreakdown[];
  source_state: VenueAnalyticsEventSourceState;
  source_message?: string;
}
export interface VenueAnalyticsComparisonResult {
  eligible_events: VenueAnalyticsTrendEventOption[];
  left_event_id?: string | null;
  right_event_id?: string | null;
  left_event?: VenueAnalyticsComparisonEvent;
  right_event?: VenueAnalyticsComparisonEvent;
  metrics: VenueAnalyticsComparisonMetric[];
  comparison_state: VenueAnalyticsComparisonState;
  comparison_message?: string;
}
export interface VenueAnalyticsRecurringPerformanceResult {
  happy_hour_items: VenueAnalyticsRecurringItem[];
  fixture_items: VenueAnalyticsRecurringItem[];
  slot_rankings?: VenueAnalyticsFixtureSlotRanking[];
  slot_state: VenueAnalyticsRecurringSlotState;
  slot_message?: string;
}
export interface VenueAnalyticsRetentionResult {
  range_start: string;
  range_end: string;
  points: VenueAnalyticsRetentionPoint[];
  retention_state: VenueAnalyticsRetentionState;
  retention_message?: string;
}
export interface VenueAnalyticsFollowerGrowthResult {
  range_start: string;
  range_end: string;
  points: VenueAnalyticsFollowerGrowthPoint[];
  follower_growth_state: VenueAnalyticsFollowerGrowthState;
  follower_growth_message?: string;
}
export interface DiscordIntakeDiagnostics {
  review_status: DiscordIntakeReviewStatus;
  reason?: string | null;
  confidence?: number | null;
  venue_match_state: DiscordIntakeVenueMatchState;
  source_type: string;
  source_url?: string | null;
  source_filename?: string | null;
  last_reprocessed_at?: string | null;
  last_reprocess_error?: string | null;
  has_debug_payload: boolean;
}
export interface VenueDeal {
  id: string;
  organization_id: string;
  venue_id: string;
  title: string;
  description: string;
  category: VenueDealCategory;
  status: VenueDealStatus;
  active_days: VenueWeekday[];
  starts_at_local: string;
  ends_at_local: string;
  skipped_dates: string[];
  archived_at?: string | null;
  created_at: string;
  updated_at: string;
}
export interface VenueDealsResult {
  deals: VenueDeal[];
}
export interface VenueFixture {
  id: string;
  organization_id: string;
  venue_id: string;
  title: string;
  description: string;
  status: VenueFixtureStatus;
  active_days: VenueWeekday[];
  starts_at_local: string;
  ends_at_local: string;
  age_restriction: EventAgeRestriction;
  capacity: number /* int32 */;
  tags: string[];
  event_url: string;
  ticket_url: string;
  is_free: boolean;
  price: string;
  poster_images: EventImageAsset[];
  next_event?: VenueFixtureEvent | null;
  skipped_count: number /* int64 */;
  archived_at?: string | null;
  created_at: string;
  updated_at: string;
}
export interface VenueFixtureEvent {
  id: string;
  title: string;
  starts_at: string;
  ends_at?: string | null;
  status: EventStatus;
}
export interface VenueFixturesResult {
  fixtures: VenueFixture[];
}
export interface GenerateVenueFixtureEventsRequest {
  occurrence_count: number /* int32 */;
}
export interface GenerateVenueFixtureEventsResult {
  events: EventRecord[];
}
export interface VenuePublicDeal {
  id: string;
  venue_id: string;
  venue_name: string;
  title: string;
  description: string;
  category: VenueDealCategory;
  status: VenueDealStatus;
  active_days: VenueWeekday[];
  starts_at_local: string;
  ends_at_local: string;
  skipped_dates: string[];
  latitude?: number /* float64 */;
  longitude?: number /* float64 */;
  logo_url?: string;
  distance_meters?: number /* float64 */;
  is_saved: boolean;
}
export interface VenueFollowerSummary {
  user_id: string;
  username: string;
  display_name: string;
  avatar_url: string;
}
export interface VenueFollowersResponse {
  followers: VenueFollowerSummary[];
}
export interface SendVenueAnnouncementRequest {
  title: string;
  message: string;
  linked_event_id?: string | null;
}
export interface SendVenueAnnouncementResult {
  recipient_count: number /* int64 */;
}
/**
 * GlobalSearchResult groups event, profile, venue, and deal results into one payload.
 */
export interface GlobalSearchResult {
  events: DiscoveryEvent[];
  profiles: ProfileSummary[];
  venues: VenueSummary[];
  deals: VenuePublicDeal[];
}
/**
 * AuthResult contains the issued session tokens and viewer identity.
 */
export interface AuthResult {
  access_token: string;
  access_token_expires_at: string;
  refresh_token: string;
  refresh_token_expires_at: string;
  user: UserSummary;
  profile: AuthProfile;
  is_new_user: boolean;
  email_verified: boolean;
  email_delivery_failed: boolean;
}
/**
 * MeResult is the authenticated viewer payload.
 */
export interface MeResult {
  user: UserSummary;
  profile: AuthProfile;
  email_verified: boolean;
  email_delivery_failed: boolean;
}
export interface UpdateEmailRequest {
  email: string;
}
export interface UpdateEmailResult {
  me: MeResult;
  verification_email_sent: boolean;
}
/**
 * VersionResult describes the app-version gate state for the current client.
 */
export interface VersionResult {
  min_supported: string;
  latest: string;
  update_required: boolean;
  update_message: string;
}
/**
 * StudioReviewPendingResult is the staff-only pending event review queue.
 */
export interface StudioReviewPendingResult {
  events: StudioReviewPendingEvent[];
}
/**
 * StudioReviewPendingEvent is the compact row model for Studio event review.
 */
export interface StudioReviewPendingEvent {
  id: string;
  title: string;
  description: string;
  venue_id: string;
  venue_name: string;
  address: string;
  host_username: string;
  starts_at?: string | null;
  ends_at?: string | null;
  doors_at?: string | null;
  last_entry_time?: string | null;
  created_at: string;
  updated_at: string;
  status: EventStatus;
  source: string;
  source_url: string;
  flyer_url: string;
  entry_type: EntryType;
  cover_price: string;
  cover_notes: string;
  rsvp_limit?: number | null;
  ticket_url: string;
  age_restriction: string;
  extraction_confidence?: number | null;
  curation_auto_approve: boolean;
  curation_reason: string;
  review_bucket: string;
  review_flags: StudioReviewFlag[];
  ready_for_approval: boolean;
  review_url: string;
}
/**
 * StudioReviewEventDetailResult is the full staff review cockpit payload for one pending event.
 */
export interface StudioReviewEventDetailResult {
  event: StudioReviewPendingEvent;
  cockpit: StudioReviewCockpit;
  source: StudioReviewSourceContext;
  flyer?: StudioReviewFlyer | null;
  geo: StudioEventGeoDiagnostic;
  advanced: StudioEventAdvancedDetails;
  tags: string[];
  attributes: string[];
  tag_options: StudioReviewTagOption[];
  attribute_options: StudioReviewAttributeOption[];
  venue_options: StudioReviewVenueOption[];
  host_options: StudioReviewHostOption[];
  siblings: StudioReviewSiblingEvent[];
  warnings: StudioReviewWarning[];
  admin_review_url: string;
  admin_edit_url: string;
}
/**
 * StudioReviewCockpit mirrors the high-signal metadata shown in the legacy review header.
 */
export interface StudioReviewCockpit {
  bucket_label: string;
  title: string;
  venue_label: string;
  date_label: string;
  end_label: string;
  entry_label: string;
  ticket_label: string;
  age_label: string;
  source_label: string;
  confidence_label: string;
  flyer_label: string;
  tags_label: string;
}
/**
 * StudioReviewSourceContext gives staff the source links and extracted context used during intake review.
 */
export interface StudioReviewSourceContext {
  has_source_url: boolean;
  source_url: string;
  source_host: string;
  source_label: string;
  instagram_post_url: string;
  instagram_profile_url: string;
  instagram_search_url: string;
  web_search_url: string;
  venue_query: string;
  event_query: string;
  flyer_url: string;
  extracted_title: string;
  extracted_venue: string;
  extracted_address: string;
  extracted_time: string;
  extracted_entry: string;
  extracted_tags: string;
  extracted_decision: string;
  decision_reason: string;
  debug_payload: string;
  raw_source_text: string;
  instagram_caption: string;
  instagram_timestamp: string;
  instagram_owner_hint: string;
  extracted_values: StudioReviewExtractedValue[];
  reprocess_url: string;
  export_context_url: string;
  export_fixture_url: string;
}
/**
 * StudioReviewExtractedValue is one source-extracted baseline value that can reset a review field.
 */
export interface StudioReviewExtractedValue {
  field: string;
  label: string;
  value: string;
}
/**
 * StudioReviewFlyer is the current poster frame used for review.
 */
export interface StudioReviewFlyer {
  url: string;
  focal_point_x: number /* float64 */;
  focal_point_y: number /* float64 */;
  focal_scale: number /* float64 */;
  requires_confirmation: boolean;
}
/**
 * StudioEventGeoDiagnostic explains whether an event can be placed in a supported market.
 */
export interface StudioEventGeoDiagnostic {
  latitude: number /* float64 */;
  longitude: number /* float64 */;
  has_coordinates: boolean;
  actual_county_geoid: string;
  actual_county_name: string;
  actual_state_code: string;
  actual_county_label: string;
  current_market_id: string;
  current_market_name: string;
  current_market_label: string;
  suggested_market_id: string;
  suggested_market_name: string;
  suggested_market_label: string;
  geo_status: StudioEventGeoStatus;
  geo_status_label: string;
}
/**
 * StudioEventAdvancedDetails carries lower-frequency event fields that still matter before approval.
 */
export interface StudioEventAdvancedDetails {
  event_url: string;
  capacity: string;
  language: string;
  event_format: string;
  presented_by: string;
  event_hashtag: string;
  dress_code: string;
  parking_info: string;
  contact_email: string;
  contact_phone: string;
  rain_plan: string;
  weather_dependent: boolean;
  is_private: boolean;
  host_id: string;
}
/**
 * StudioReviewTagOption is an active event tag available during review.
 */
export interface StudioReviewTagOption {
  slug: string;
  label: string;
  category_group: string;
}
/**
 * StudioReviewAttributeOption is an active event attribute available during review.
 */
export interface StudioReviewAttributeOption {
  slug: string;
  label: string;
}
/**
 * StudioReviewVenueOption is a venue candidate available for linking during review.
 */
export interface StudioReviewVenueOption {
  id: string;
  name: string;
  address: string;
  verified: boolean;
}
/**
 * StudioReviewHostOption is an admin-selectable event owner.
 */
export interface StudioReviewHostOption {
  id: string;
  username: string;
  display_name: string;
  venue_name: string;
  label: string;
}
/**
 * StudioReviewSiblingEvent is another pending intake row with the same title.
 */
export interface StudioReviewSiblingEvent {
  id: string;
  title: string;
  venue_name: string;
  starts_at?: string | null;
  ends_at?: string | null;
  flyer_url: string;
}
/**
 * StudioReviewWarning is an operator-facing review warning.
 */
export interface StudioReviewWarning {
  label: string;
  message: string;
  tone: string;
  target: string;
}
/**
 * StudioReviewFlag describes why an event needs staff attention.
 */
export interface StudioReviewFlag {
  label: string;
  tone: string;
  target: string;
}
/**
 * StudioRejectReviewEventRequest rejects a pending event from Studio.
 */
export interface StudioRejectReviewEventRequest {
  note: string;
}
/**
 * StudioSaveReviewEventRequest updates the publish-critical review fields for a pending event.
 */
export interface StudioSaveReviewEventRequest {
  title: string;
  description: string;
  venue_id?: string | null;
  venue_name: string;
  address: string;
  starts_at: string;
  ends_at: string;
  doors_at: string;
  last_entry_time: string;
  entry_type: EntryType;
  cover_price: string;
  cover_notes: string;
  rsvp_limit: string;
  ticket_url: string;
  source_url: string;
  age_restriction: string;
  status: string;
  event_url: string;
  capacity: string;
  language: string;
  event_format: string;
  presented_by: string;
  event_hashtag: string;
  dress_code: string;
  parking_info: string;
  contact_email: string;
  contact_phone: string;
  rain_plan: string;
  weather_dependent: boolean;
  is_private: boolean;
  host_id: string;
  tags: string[];
  attributes: string[];
}
/**
 * StudioDuplicateEventRequest requires a fresh start time for a copied event.
 */
export interface StudioDuplicateEventRequest {
  starts_at: string;
}
/**
 * StudioApproveReviewEventRequest controls whether approval should advance to the next candidate.
 */
export interface StudioApproveReviewEventRequest {
  next: boolean;
}
/**
 * StudioApproveReviewEventResult returns the next review candidate after approval when one exists.
 */
export interface StudioApproveReviewEventResult {
  next_event_id?: string | null;
}
/**
 * StudioBulkEventIDsRequest targets a staff-selected set of events.
 */
export interface StudioBulkEventIDsRequest {
  ids: string[];
}
/**
 * StudioBulkEventActionResult reports how many selected events changed.
 */
export interface StudioBulkEventActionResult {
  requested: number /* int32 */;
  changed: number /* int32 */;
  skipped: number /* int32 */;
  ids: string[];
}
/**
 * StudioSourceImportRequest creates a pending review event from a staff-provided source.
 */
export interface StudioSourceImportRequest {
  source_url: string;
  source_text: string;
  venue_id: string;
  venue_hint: string;
  notes: string;
}
/**
 * StudioSourceImportResult returns the pending event created from a staff source import.
 */
export interface StudioSourceImportResult {
  event_id: string;
  review_url: string;
}
/**
 * StudioInstagramURLImportRequest creates pending review candidates from exact staff-selected Instagram URLs.
 */
export interface StudioInstagramURLImportRequest {
  urls: string[];
  venue_hint: string;
  notes: string;
  source_id: string;
}
export interface StudioInstagramURLImportResult {
  run: StudioEventImportRunSummary;
  review_url: string;
}
export const StudioBrowserPageKindInstagramProfile = "instagram_profile";
export const StudioBrowserPageKindInstagramPost = "instagram_post";
export const StudioBrowserPageKindInstagramReel = "instagram_reel";
export const StudioBrowserPageKindFacebookEvent = "facebook_event";
export const StudioBrowserPageKindWebsite = "website";
export const StudioBrowserPageKindUnknown = "unknown";
export type StudioBrowserPageKind = typeof StudioBrowserPageKindInstagramProfile | typeof StudioBrowserPageKindInstagramPost | typeof StudioBrowserPageKindInstagramReel | typeof StudioBrowserPageKindFacebookEvent | typeof StudioBrowserPageKindWebsite | typeof StudioBrowserPageKindUnknown;
export const StudioBrowserSuggestedActionCreateSource = "create_source";
export const StudioBrowserSuggestedActionRunSource = "run_source";
export const StudioBrowserSuggestedActionImportURL = "import_url";
export const StudioBrowserSuggestedActionOpenReview = "open_review";
export const StudioBrowserSuggestedActionOpenVenue = "open_venue";
export const StudioBrowserSuggestedActionSetCheckpoint = "set_checkpoint";
export const StudioBrowserSuggestedActionReviewCandidates = "review_candidates";
export type StudioBrowserSuggestedAction = typeof StudioBrowserSuggestedActionCreateSource | typeof StudioBrowserSuggestedActionRunSource | typeof StudioBrowserSuggestedActionImportURL | typeof StudioBrowserSuggestedActionOpenReview | typeof StudioBrowserSuggestedActionOpenVenue | typeof StudioBrowserSuggestedActionSetCheckpoint | typeof StudioBrowserSuggestedActionReviewCandidates;
export interface StudioBrowserContextResolveRequest {
  url: string;
  page_title: string;
}
export interface StudioBrowserContextResolveResult {
  normalized_url: string;
  page_kind: StudioBrowserPageKind;
  venue_match?: StudioBrowserVenueMatch | null;
  event_source_match?: StudioBrowserEventSourceMatch | null;
  prior_import_match?: StudioBrowserPriorImportMatch | null;
  suggested_actions: StudioBrowserSuggestedAction[];
}
export interface StudioBrowserVenueMatch {
  id: string;
  name: string;
  address: string;
  match_type: string;
}
export interface StudioBrowserEventSourceMatch {
  id: string;
  name: string;
  url: string;
  source_type: EventImportSourceType;
  status: EventImportSourceStatus;
  permission_status: EventImportPermissionStatus;
  venue_id: string;
  venue_name: string;
  pending_candidate_count: number /* int32 */;
  latest_pending_run_id: string;
  latest_run?: StudioEventImportRunSummary | null;
  last_checked_at?: string | null;
  last_success_at?: string | null;
  last_error: string;
  browser_checkpoint_url: string;
  browser_checkpoint_label: string;
  browser_checkpoint_at?: string | null;
  browser_checkpoint_by_label: string;
}
export interface StudioBrowserPriorImportMatch {
  import_item_id: string;
  run_id: string;
  event_id: string;
  status: EventImportItemStatus;
  review_url: string;
  source_url: string;
  error: string;
}
export interface StudioEventSourceCheckpointRequest {
  url: string;
  external_id: string;
  label: string;
}
export const EventImportSourceTypeOfficialCalendar = "official_calendar";
export const EventImportSourceTypeTicketing = "ticketing";
export const EventImportSourceTypeVenueSite = "venue_site";
export const EventImportSourceTypeInstagram = "instagram";
export const EventImportSourceTypeJSONFeed = "json_feed";
export const EventImportSourceTypeManual = "manual";
export type EventImportSourceType = typeof EventImportSourceTypeOfficialCalendar | typeof EventImportSourceTypeTicketing | typeof EventImportSourceTypeVenueSite | typeof EventImportSourceTypeInstagram | typeof EventImportSourceTypeJSONFeed | typeof EventImportSourceTypeManual;
export const EventImportSourceStatusActive = "active";
export const EventImportSourceStatusPaused = "paused";
export const EventImportSourceStatusArchived = "archived";
export const EventImportSourceStatusBlocked = "blocked";
export type EventImportSourceStatus = typeof EventImportSourceStatusActive | typeof EventImportSourceStatusPaused | typeof EventImportSourceStatusArchived | typeof EventImportSourceStatusBlocked;
export const EventImportPermissionStatusPublicCuration = "public_curation";
export const EventImportPermissionStatusGranted = "venue_permission_granted";
export const EventImportPermissionStatusRequested = "permission_requested";
export const EventImportPermissionStatusDoNotImport = "do_not_import";
export type EventImportPermissionStatus = typeof EventImportPermissionStatusPublicCuration | typeof EventImportPermissionStatusGranted | typeof EventImportPermissionStatusRequested | typeof EventImportPermissionStatusDoNotImport;
export const EventImportImageUsagePolicyReviewOnly = "review_only";
export const EventImportImageUsagePolicyAllowed = "allowed";
export const EventImportImageUsagePolicyDoNotUse = "do_not_use";
export type EventImportImageUsagePolicy = typeof EventImportImageUsagePolicyReviewOnly | typeof EventImportImageUsagePolicyAllowed | typeof EventImportImageUsagePolicyDoNotUse;
export const EventImportPosterStrategySourceImage = "source_image";
export const EventImportPosterStrategyGenerate = "generate";
export type EventImportPosterStrategy = typeof EventImportPosterStrategySourceImage | typeof EventImportPosterStrategyGenerate;
export const EventImportDescriptionUsagePolicyFactsOnly = "facts_only";
export const EventImportDescriptionUsagePolicyAllowed = "allowed";
export const EventImportDescriptionUsagePolicyDoNotUse = "do_not_use";
export const EventImportDescriptionUsagePolicyAIRewrite = "ai_rewrite";
export type EventImportDescriptionUsagePolicy = typeof EventImportDescriptionUsagePolicyFactsOnly | typeof EventImportDescriptionUsagePolicyAllowed | typeof EventImportDescriptionUsagePolicyDoNotUse | typeof EventImportDescriptionUsagePolicyAIRewrite;
export type EventImportReviewPolicy = string;
export const EventImportReviewPolicyRadiousReview: EventImportReviewPolicy = "radious_review";
export const EventImportRunStatusRunning = "running";
export const EventImportRunStatusSucceeded = "succeeded";
export const EventImportRunStatusFailed = "failed";
export type EventImportRunStatus = typeof EventImportRunStatusRunning | typeof EventImportRunStatusSucceeded | typeof EventImportRunStatusFailed;
export const EventImportRunModeManualSingle = "manual_single";
export const EventImportRunModeInstagramURLList = "instagram_url_list";
export type EventImportRunMode = typeof EventImportRunModeManualSingle | typeof EventImportRunModeInstagramURLList;
export const EventImportRunWindowToday = "today";
export const EventImportRunWindowThisWeek = "this_week";
export const EventImportRunWindowThisMonth = "this_month";
export const EventImportRunWindowAllUpcoming = "all_upcoming";
export type EventImportRunWindow = typeof EventImportRunWindowToday | typeof EventImportRunWindowThisWeek | typeof EventImportRunWindowThisMonth | typeof EventImportRunWindowAllUpcoming;
export const EventImportItemStatusCreatedPending = "created_pending";
export const EventImportItemStatusDuplicate = "duplicate";
export const EventImportItemStatusFailed = "failed";
export const EventImportItemStatusSkipped = "skipped";
export type EventImportItemStatus = typeof EventImportItemStatusCreatedPending | typeof EventImportItemStatusDuplicate | typeof EventImportItemStatusFailed | typeof EventImportItemStatusSkipped;
export interface StudioEventSourcesResult {
  sources: StudioEventSourceRow[];
}
export interface StudioEventSourceRow {
  id: string;
  venue_id: string;
  venue_name: string;
  organization_id: string;
  organization_name: string;
  name: string;
  source_type: EventImportSourceType;
  url: string;
  adapter: string;
  status: EventImportSourceStatus;
  permission_status: EventImportPermissionStatus;
  permission_notes: string;
  permission_contact_name: string;
  permission_contact_email: string;
  permission_recorded_at?: string | null;
  image_usage_policy: EventImportImageUsagePolicy;
  poster_strategy: EventImportPosterStrategy;
  description_usage_policy: EventImportDescriptionUsagePolicy;
  review_policy: EventImportReviewPolicy;
  future_days: number /* int32 */;
  check_interval_hours: number /* int32 */;
  last_checked_at?: string | null;
  last_success_at?: string | null;
  last_error: string;
  pending_candidate_count: number /* int32 */;
  latest_pending_run_id: string;
  latest_run?: StudioEventImportRunSummary | null;
  browser_checkpoint_url: string;
  browser_checkpoint_external_id: string;
  browser_checkpoint_label: string;
  browser_checkpoint_at?: string | null;
  created_at: string;
  updated_at: string;
}
export interface StudioEventImportRunSummary {
  id: string;
  status: EventImportRunStatus;
  started_at?: string | null;
  finished_at?: string | null;
  fetched_count: number /* int32 */;
  created_pending_count: number /* int32 */;
  duplicate_count: number /* int32 */;
  failed_count: number /* int32 */;
  error: string;
}
export interface StudioEventSourceRequest {
  venue_id: string;
  organization_id: string;
  name: string;
  source_type: EventImportSourceType;
  url: string;
  adapter: string;
  status: EventImportSourceStatus;
  permission_status: EventImportPermissionStatus;
  permission_notes: string;
  permission_contact_name: string;
  permission_contact_email: string;
  permission_recorded_at: string;
  image_usage_policy: EventImportImageUsagePolicy;
  poster_strategy: EventImportPosterStrategy;
  description_usage_policy: EventImportDescriptionUsagePolicy;
  review_policy: EventImportReviewPolicy;
  future_days: number /* int32 */;
  check_interval_hours: number /* int32 */;
}
export interface StudioEventSourceRunRequest {
  source_text: string;
  venue_hint: string;
  notes: string;
  window: EventImportRunWindow;
  max_events: number /* int32 */;
  dry_run: boolean;
}
export interface StudioEventSourceRunResult {
  run: StudioEventImportRunSummary;
  event_id?: string | null;
  review_url: string;
  preview?: StudioEventSourceRunPreview | null;
  created_event: boolean;
}
export interface StudioEventSourceRunPreview {
  title: string;
  venue_name: string;
  starts_at?: string | null;
  source_url: string;
  confidence: number /* int32 */;
}
export interface StudioEventImportRunDetailResult {
  run: StudioEventImportRunSummary;
  items: StudioEventImportItemRow[];
}
export interface StudioEventImportItemRow {
  id: string;
  event_id: string;
  source_url: string;
  external_id: string;
  extracted_title: string;
  extracted_venue: string;
  extracted_starts: string;
  status: EventImportItemStatus;
  confidence_score?: number | null;
  changed_fields: string[];
  error: string;
  created_at: string;
}
export const StudioEventsActivityFilterAll = "all";
export const StudioEventsActivityFilterActiveInApp = "active_in_app";
export const StudioEventsActivityFilterEndedActive = "ended_active";
export const StudioEventsActivityFilterPending = "pending";
export const StudioEventsActivityFilterRejected = "rejected";
export const StudioEventsActivityFilterCancelled = "cancelled";
export type StudioEventsActivityFilter = typeof StudioEventsActivityFilterAll | typeof StudioEventsActivityFilterActiveInApp | typeof StudioEventsActivityFilterEndedActive | typeof StudioEventsActivityFilterPending | typeof StudioEventsActivityFilterRejected | typeof StudioEventsActivityFilterCancelled;
export const StudioEventGeoStatusInMarket = "in_market";
export const StudioEventGeoStatusWrongMarket = "wrong_market";
export const StudioEventGeoStatusOutsideSupportedMarkets = "outside_supported_markets";
export const StudioEventGeoStatusUnresolved = "unresolved";
export type StudioEventGeoStatus = typeof StudioEventGeoStatusInMarket | typeof StudioEventGeoStatusWrongMarket | typeof StudioEventGeoStatusOutsideSupportedMarkets | typeof StudioEventGeoStatusUnresolved;
export const StudioEventsSortStartsAtAsc = "starts_at_asc";
export const StudioEventsSortStartsAtDesc = "starts_at_desc";
export const StudioEventsSortCreatedDesc = "created_desc";
export type StudioEventsSort = typeof StudioEventsSortStartsAtAsc | typeof StudioEventsSortStartsAtDesc | typeof StudioEventsSortCreatedDesc;
export const StudioEventsTimeWindowAll = "all";
export const StudioEventsTimeWindowToday = "today";
export const StudioEventsTimeWindowNext7 = "next_7";
export const StudioEventsTimeWindowFuture = "future";
export type StudioEventsTimeWindow = typeof StudioEventsTimeWindowAll | typeof StudioEventsTimeWindowToday | typeof StudioEventsTimeWindowNext7 | typeof StudioEventsTimeWindowFuture;
export interface StudioEventsResult {
  events: StudioEventRow[];
  stats: StudioEventsStats;
  paging: StudioEventsPaging;
}
export interface StudioEventsStats {
  total_events: number /* int64 */;
  active_events: number /* int64 */;
  ended_active_events: number /* int64 */;
  total_rsvps: number /* int64 */;
  total_for_filter: number /* int64 */;
}
export interface StudioEventsPaging {
  activity_filter: StudioEventsActivityFilter;
  sort: StudioEventsSort;
  time_window: StudioEventsTimeWindow;
  page: number /* int32 */;
  page_size: number /* int32 */;
  total_pages: number /* int32 */;
  has_previous: boolean;
  has_next: boolean;
}
export interface StudioEventRow {
  id: string;
  title: string;
  venue_name: string;
  address: string;
  ticket_url: string;
  source_url: string;
  entry_type: string;
  starts_at: string;
  ends_at?: string | null;
  status: string;
  is_cancelled: boolean;
  is_active_in_app: boolean;
  has_image: boolean;
  poster_url: string;
  host_username: string;
  rsvp_count: number /* int64 */;
  latitude: number /* float64 */;
  longitude: number /* float64 */;
  has_coordinates: boolean;
  actual_county_label: string;
  current_market_label: string;
  suggested_market_label: string;
  geo_status: StudioEventGeoStatus;
  geo_status_label: string;
}
export interface StudioResolveEventCoordinatesResult {
  event: StudioEventRow;
  geo: StudioEventGeoDiagnostic;
}
export interface StudioVenuesResult {
  venues: StudioVenueRow[];
  stats: StudioVenuesStats;
}
export interface StudioVenueDetailResult {
  venue: StudioVenueRow;
  organizations: StudioOrganizationRow[];
}
export interface StudioVenuesStats {
  total_venues: number /* int32 */;
  unclaimed_venues: number /* int32 */;
  venue_claims: number /* int32 */;
  custom_venues: number /* int32 */;
  geo_issues: number /* int32 */;
  unverified_venues: number /* int32 */;
}
export interface StudioVenueRow {
  id: string;
  name: string;
  slug: string;
  address: string;
  city: string;
  state: string;
  latitude?: number /* float64 */;
  longitude?: number /* float64 */;
  phone: string;
  email: string;
  category: string;
  website: string;
  instagram_handle: string;
  description: string;
  logo_url: string;
  cover_url: string;
  is_verified: boolean;
  is_claimed: boolean;
  claimed_by_label: string;
  event_count: number /* int64 */;
  has_coordinates: boolean;
  actual_county_label: string;
  current_market_label: string;
  suggested_market_label: string;
  geo_status: StudioEventGeoStatus;
  geo_status_label: string;
}
export interface StudioSaveVenueRequest {
  name: string;
  address: string;
  latitude?: number /* float64 */;
  longitude?: number /* float64 */;
  phone: string;
  email: string;
  category: string;
  website: string;
  instagram_handle: string;
  description: string;
  logo_url: string;
  cover_url: string;
  is_verified: boolean;
}
export interface StudioCreateVenueRequest {
  name: string;
  address: string;
  latitude?: number /* float64 */;
  longitude?: number /* float64 */;
  phone: string;
  email: string;
  category: string;
  website: string;
  instagram_handle: string;
  description: string;
  logo_url: string;
  cover_url: string;
  is_verified: boolean;
  backfill_venue_name: string;
  backfill_address: string;
}
export interface StudioMarketsResult {
  markets: StudioMarketRow[];
  stats: StudioMarketsStats;
}
export interface StudioMarketsStats {
  total_markets: number /* int32 */;
  active_markets: number /* int32 */;
  county_count: number /* int32 */;
  inactive_markets: number /* int32 */;
}
export interface StudioMarketRow {
  id: string;
  name: string;
  slug: string;
  state_code: string;
  browse_lat: number /* float64 */;
  browse_lng: number /* float64 */;
  browse_radius_meters: number /* int32 */;
  is_active: boolean;
  time_zone: string;
  counties: StudioMarketCountyRow[];
  created_at: string;
  updated_at: string;
}
export interface StudioMarketCountyRow {
  market_id: string;
  county_geoid: string;
  state_code: string;
  county_name: string;
  namelsad: string;
  label: string;
}
export interface StudioMarketRequest {
  name: string;
  slug: string;
  state_code: string;
  browse_lat: number /* float64 */;
  browse_lng: number /* float64 */;
  browse_radius_meters: number /* int32 */;
  is_active: boolean;
}
export interface StudioMarketCountyRequest {
  county_geoid: string;
}
export interface StudioCountySearchResult {
  counties: StudioCountySearchRow[];
}
export interface StudioCountySearchRow {
  geoid: string;
  county_name: string;
  label: string;
  state_code: string;
}
export interface StudioOrganizationsResult {
  organizations: StudioOrganizationRow[];
  stats: StudioOrganizationsStats;
}
export interface StudioOrganizationDetailResult {
  organization: StudioOrganizationRow;
  members: OrganizationMemberSummary[];
  venues: OrganizationMemberVenueScope[];
}
export interface StudioOrganizationsStats {
  total_organizations: number /* int32 */;
  setup_complete: number /* int32 */;
  needs_setup: number /* int32 */;
  without_owner: number /* int32 */;
  pending_invites: number /* int32 */;
  linked_venues: number /* int32 */;
}
export interface StudioOrganizationRow {
  id: string;
  name: string;
  slug: string;
  primary_owner_email: string;
  member_count: number /* int32 */;
  owner_count: number /* int32 */;
  venue_count: number /* int32 */;
  pending_invite_count: number /* int32 */;
  setup_complete: boolean;
  subscription_plan: string;
  billing_status: string;
  created_at: string;
}
export interface StudioModerationResult {
  reports: StudioReportRow[];
  venue_claims: StudioVenueClaimRow[];
  custom_venues: StudioCustomVenueRow[];
  ignored_venues: StudioIgnoredVenueRow[];
  rejected_intake: StudioRejectedIntakeRow[];
  stats: StudioModerationStats;
}
export interface StudioModerationStats {
  open_reports: number /* int64 */;
  venue_claims: number /* int32 */;
  custom_venues: number /* int32 */;
  ignored_venues: number /* int32 */;
  rejected_intake: number /* int32 */;
}
export interface StudioUsersResult {
  users: StudioUserRow[];
  stats: StudioUsersStats;
  apple_review: StudioAppleReviewInfo;
}
export interface StudioUsersStats {
  total: number /* int32 */;
  verified: number /* int32 */;
  staff: number /* int32 */;
  banned: number /* int32 */;
  venues: number /* int32 */;
}
export interface StudioUserRow {
  id: string;
  email: string;
  email_verified: boolean;
  is_staff: boolean;
  username: string;
  display_name: string;
  is_venue: boolean;
  venue_name: string;
  is_banned: boolean;
  ban_reason: string;
  created_at: string;
  legacy_admin_path: string;
}
export interface StudioAppleReviewInfo {
  email: string;
  exists: boolean;
}
export interface StudioUserStaffRequest {
  is_staff: boolean;
}
export interface StudioAppleReviewCreateResult {
  user: StudioUserRow;
  password: string;
}
export interface StudioAppleReviewRevokeResult {
  revoked: boolean;
}
export interface StudioAuditResult {
  entries: StudioAuditEntryRow[];
  paging: StudioAuditPaging;
}
export interface StudioAuditFilters {
  Search: string;
  Action: StudioAuditAction;
  TargetType: StudioAuditTargetType;
  FromAt?: string;
  ToAt?: string;
  Page: number /* int32 */;
  PerPage: number /* int32 */;
}
export interface StudioAuditPaging {
  page: number /* int32 */;
  per_page: number /* int32 */;
  total: number /* int32 */;
  pages: number /* int32 */;
}
export interface StudioAuditEntryRow {
  id: string;
  actor_user_id: string;
  actor_label: string;
  action: string;
  target_type: string;
  target_id: string;
  target_name: string;
  reason: string;
  href: string;
  created_at: string;
}
export type StudioAuditAction = string;
export type StudioAuditTargetType = string;
export interface StudioOpsResult {
  summary: StudioOpsSummary;
  supply: StudioOpsSupplySummary;
  top_review: StudioOpsReviewItem[];
  deploy_status: StudioOpsDeployStatus;
  status_monitor: StudioOpsStatusMonitor;
  analytics_delivery: StudioOpsAnalyticsDelivery;
  resource_groups: StudioOpsResourceGroup[];
  embeds: StudioOpsEmbed[];
  updated_at: string;
}
export const StudioOpsAnalyticsDeliveryStateHealthy = "healthy";
export const StudioOpsAnalyticsDeliveryStateWarning = "warning";
export const StudioOpsAnalyticsDeliveryStateCritical = "critical";
export const StudioOpsAnalyticsDeliveryStateDisabled = "disabled";
export const StudioOpsAnalyticsDeliveryStateUnavailable = "unavailable";
export type StudioOpsAnalyticsDeliveryState = typeof StudioOpsAnalyticsDeliveryStateHealthy | typeof StudioOpsAnalyticsDeliveryStateWarning | typeof StudioOpsAnalyticsDeliveryStateCritical | typeof StudioOpsAnalyticsDeliveryStateDisabled | typeof StudioOpsAnalyticsDeliveryStateUnavailable;
export interface StudioOpsAnalyticsDelivery {
  state: StudioOpsAnalyticsDeliveryState;
  pending_count: number /* int64 */;
  oldest_pending_seconds: number /* int64 */;
  delivered_recent: number /* int64 */;
  retry_recent: number /* int64 */;
  permanent_failure_recent: number /* int64 */;
  last_success_at?: string | null;
  last_failure_category?: string;
  message: string;
}
export interface StudioGrowthResult {
  range: StudioGrowthRange;
  metrics: StudioGrowthMetric[];
  insights: string[];
  daily_new_users: StudioGrowthDailyNewUsers[];
  platform_breakdown: StudioGrowthPlatformBreakdown[];
  qr_breakdown: StudioGrowthQRBreakdown[];
  qr_codes: StudioGrowthQRCode[];
  top_venues: StudioGrowthVenuePerformance[];
  top_events: StudioGrowthEventPerformance[];
  updated_at: string;
}
export interface StudioGrowthRange {
  days: number /* int32 */;
  start_at: string;
  end_at: string;
  previous_start_at: string;
  previous_end_at: string;
  label: string;
}
export interface StudioGrowthMetric {
  key: string;
  label: string;
  group: string;
  value: number /* float64 */;
  previous_value: number /* float64 */;
  delta_percent: number /* float64 */;
  format: string;
  help: string;
}
export interface StudioGrowthDailyNewUsers {
  day: string;
  new_users: number /* int64 */;
}
export interface StudioGrowthPlatformBreakdown {
  platform: string;
  app_opens: number /* int64 */;
}
export interface StudioGrowthQRBreakdown {
  slug: string;
  label: string;
  source: string;
  total_scans: number /* int64 */;
  unique_scans: number /* int64 */;
}
export interface StudioGrowthQRCode {
  id: string;
  slug: string;
  label: string;
  destination_url: string;
  is_active: boolean;
  total_scans: number /* int64 */;
  last_scanned_at?: string | null;
}
export interface StudioQRCodeRequest {
  label: string;
  slug: string;
  destination_url: string;
}
export interface StudioQRCodeActiveRequest {
  is_active: boolean;
}
export type GrowthCampaignStatus = string;
export type GrowthCampaignDestinationType = string;
export type GrowthCampaignConversionType = string;
export interface StudioGrowthCampaignPlacementRequest {
  name: string;
  slug: string;
  utm_source: string;
  utm_medium: string;
}
export interface StudioGrowthCampaignCreateRequest {
  name: string;
  slug: string;
  description: string;
  headline: string;
  call_to_action: string;
  destination_type: GrowthCampaignDestinationType;
  destination_url: string;
  destination_entity_id?: string | null;
  starts_at?: string | null;
  ends_at?: string | null;
  placements: StudioGrowthCampaignPlacementRequest[];
}
export interface StudioGrowthCampaignUpdateRequest {
  name: string;
  description: string;
  headline: string;
  call_to_action: string;
  destination_url: string;
  starts_at?: string | null;
  ends_at?: string | null;
}
export interface StudioGrowthCampaignStatusRequest {
  status: GrowthCampaignStatus;
}
export type GrowthCampaignAssetTemplate = string;
export type GrowthCampaignAssetFormat = string;
export interface StudioGrowthCampaignSummary {
  id: string;
  name: string;
  slug: string;
  description: string;
  status: GrowthCampaignStatus;
  destination_type: GrowthCampaignDestinationType;
  destination_url: string;
  placement_count: number /* int64 */;
  active_placement_count: number /* int64 */;
  total_scans: number /* int64 */;
  unique_scans: number /* int64 */;
  last_scanned_at?: string | null;
}
export interface StudioGrowthCampaignMetric {
  total_scans: number /* int64 */;
  unique_scans: number /* int64 */;
  event_views: number /* int64 */;
  saves: number /* int64 */;
  rsvps: number /* int64 */;
  scan_to_view_rate: number /* float64 */;
  view_to_save_rate: number /* float64 */;
  view_to_rsvp_rate: number /* float64 */;
}
export interface StudioGrowthCampaignPlacement {
  id: string;
  name: string;
  slug: string;
  utm_source: string;
  utm_medium: string;
  is_active: boolean;
  last_scanned_at?: string | null;
  metrics: StudioGrowthCampaignMetric;
}
export interface StudioGrowthCampaignDetail {
  id: string;
  name: string;
  slug: string;
  description: string;
  headline: string;
  call_to_action: string;
  status: GrowthCampaignStatus;
  destination_type: GrowthCampaignDestinationType;
  destination_url: string;
  destination_entity_id?: string | null;
  starts_at?: string | null;
  ends_at?: string | null;
  created_at: string;
  updated_at: string;
  metrics: StudioGrowthCampaignMetric;
  placements: StudioGrowthCampaignPlacement[];
}
export interface StudioGrowthVenuePerformance {
  id: string;
  name: string;
  category: string;
  market_name: string;
  profile_views: number /* int64 */;
  event_views: number /* int64 */;
  saved_events: number /* int64 */;
  rsvps: number /* int64 */;
  directions_taps: number /* int64 */;
  website_taps: number /* int64 */;
  shares: number /* int64 */;
  follows: number /* int64 */;
  calendar_exports: number /* int64 */;
  ticket_link_taps: number /* int64 */;
}
export interface StudioGrowthEventPerformance {
  id: string;
  title: string;
  venue_name: string;
  starts_at?: string | null;
  venue_category: string;
  market_name: string;
  event_views: number /* int64 */;
  unique_viewers: number /* int64 */;
  rsvps: number /* int64 */;
  shares: number /* int64 */;
  calendar_exports: number /* int64 */;
  ticket_link_taps: number /* int64 */;
}
export interface StudioOpsSummary {
  pending_review: number /* int32 */;
  ready_review: number /* int32 */;
  needs_time: number /* int32 */;
  needs_venue: number /* int32 */;
  needs_entry: number /* int32 */;
  needs_flyer: number /* int32 */;
  venue_claims: number /* int32 */;
  custom_venues: number /* int32 */;
  rejected_intake: number /* int32 */;
  open_reports: number /* int64 */;
  venue_geo_issues: number /* int32 */;
  unverified_venues: number /* int32 */;
}
export interface StudioOpsSupplySummary {
  active_today: number /* int64 */;
  active_next_7_days: number /* int64 */;
  ready_review: number /* int32 */;
  missing_poster_next_7_days: number /* int64 */;
  geo_issue_next_7_days: number /* int64 */;
  stale_ended_active: number /* int64 */;
}
export interface StudioOpsReviewItem {
  id: string;
  title: string;
  venue: string;
  starts_at?: string;
  href: string;
}
export interface StudioOpsResourceGroup {
  title: string;
  links: StudioOpsResource[];
}
export interface StudioOpsResource {
  key: string;
  label: string;
  url: string;
  description: string;
}
export interface StudioOpsEmbed {
  key: string;
  title: string;
  url: string;
}
export const StudioOpsDeployStateHealthy = "healthy";
export const StudioOpsDeployStateWarning = "warning";
export const StudioOpsDeployStateFailing = "failing";
export const StudioOpsDeployStateUnavailable = "unavailable";
export type StudioOpsDeployState = typeof StudioOpsDeployStateHealthy | typeof StudioOpsDeployStateWarning | typeof StudioOpsDeployStateFailing | typeof StudioOpsDeployStateUnavailable;
export type StudioOpsDeployProvider = string;
export const StudioOpsDeployProviderGithubActions: StudioOpsDeployProvider = "github_actions";
export const StudioOpsWorkflowKeyAPI = "api";
export const StudioOpsWorkflowKeyStudio = "studio";
export const StudioOpsWorkflowKeyStatusMonitor = "status_monitor";
export const StudioOpsWorkflowKeyApexRouter = "apex_router";
export type StudioOpsWorkflowKey = typeof StudioOpsWorkflowKeyAPI | typeof StudioOpsWorkflowKeyStudio | typeof StudioOpsWorkflowKeyStatusMonitor | typeof StudioOpsWorkflowKeyApexRouter;
export const StudioOpsDeploySurfaceAPI = "API";
export const StudioOpsDeploySurfaceStudio = "Studio";
export const StudioOpsDeploySurfaceStatusMonitor = "Status Monitor";
export const StudioOpsDeploySurfaceApexRouter = "Apex Router";
export type StudioOpsDeploySurface = typeof StudioOpsDeploySurfaceAPI | typeof StudioOpsDeploySurfaceStudio | typeof StudioOpsDeploySurfaceStatusMonitor | typeof StudioOpsDeploySurfaceApexRouter;
export const StudioOpsWorkflowStatusQueued = "queued";
export const StudioOpsWorkflowStatusInProgress = "in_progress";
export const StudioOpsWorkflowStatusCompleted = "completed";
export const StudioOpsWorkflowStatusRequested = "requested";
export const StudioOpsWorkflowStatusWaiting = "waiting";
export const StudioOpsWorkflowStatusPending = "pending";
export const StudioOpsWorkflowStatusUnknown = "unknown";
export type StudioOpsWorkflowStatus = typeof StudioOpsWorkflowStatusQueued | typeof StudioOpsWorkflowStatusInProgress | typeof StudioOpsWorkflowStatusCompleted | typeof StudioOpsWorkflowStatusRequested | typeof StudioOpsWorkflowStatusWaiting | typeof StudioOpsWorkflowStatusPending | typeof StudioOpsWorkflowStatusUnknown;
export const StudioOpsWorkflowConclusionSuccess = "success";
export const StudioOpsWorkflowConclusionFailure = "failure";
export const StudioOpsWorkflowConclusionCancelled = "cancelled";
export const StudioOpsWorkflowConclusionSkipped = "skipped";
export const StudioOpsWorkflowConclusionTimedOut = "timed_out";
export const StudioOpsWorkflowConclusionActionRequired = "action_required";
export const StudioOpsWorkflowConclusionNeutral = "neutral";
export const StudioOpsWorkflowConclusionStale = "stale";
export const StudioOpsWorkflowConclusionUnknown = "unknown";
export type StudioOpsWorkflowConclusion = typeof StudioOpsWorkflowConclusionSuccess | typeof StudioOpsWorkflowConclusionFailure | typeof StudioOpsWorkflowConclusionCancelled | typeof StudioOpsWorkflowConclusionSkipped | typeof StudioOpsWorkflowConclusionTimedOut | typeof StudioOpsWorkflowConclusionActionRequired | typeof StudioOpsWorkflowConclusionNeutral | typeof StudioOpsWorkflowConclusionStale | typeof StudioOpsWorkflowConclusionUnknown;
export interface StudioOpsDeployStatus {
  provider: StudioOpsDeployProvider;
  repository: string;
  actions_url: string;
  state: StudioOpsDeployState;
  checked_at?: string | null;
  unavailable_reason?: string;
  workflows: StudioOpsWorkflowRun[];
}
export interface StudioOpsWorkflowRun {
  key: StudioOpsWorkflowKey;
  surface: StudioOpsDeploySurface;
  workflow_name: string;
  workflow_file: string;
  status: StudioOpsWorkflowStatus;
  conclusion: StudioOpsWorkflowConclusion;
  run_id: number /* int64 */;
  run_number: number /* int32 */;
  run_attempt: number /* int32 */;
  event: string;
  branch: string;
  commit_sha: string;
  commit_short_sha: string;
  commit_message: string;
  actor: string;
  started_at?: string | null;
  updated_at?: string | null;
  duration_seconds: number /* int64 */;
  html_url: string;
  failed_jobs: StudioOpsWorkflowJob[];
}
export interface StudioOpsWorkflowJob {
  name: string;
  status: StudioOpsWorkflowStatus;
  conclusion: StudioOpsWorkflowConclusion;
  html_url: string;
}
export interface StudioOpsStatusMonitor {
  available: boolean;
  status?: HealthStatus;
  checked_at?: string | null;
  public_notice?: StudioOpsStatusNotice | null;
  components: StudioOpsStatusComponent[];
  incidents: StudioOpsStatusNotice[];
  updates: StudioOpsStatusNotice[];
  maintenance: StudioOpsStatusMaintenance[];
  error_label?: string;
}
export interface StudioOpsStatusComponent {
  id: string;
  label: string;
  status: HealthStatus;
}
export interface StudioOpsStatusNotice {
  id: string;
  type: string;
  severity: string;
  title: string;
  message: string;
  state?: string;
  affected_components: string[];
  created_at?: string | null;
  updated_at?: string | null;
  resolved_at?: string | null;
  starts_at?: string | null;
  ends_at?: string | null;
  upcoming?: boolean;
}
export interface StudioOpsStatusMaintenance {
  id: string;
  type: string;
  severity: string;
  title: string;
  message: string;
  state?: string;
  affected_components: string[];
  created_at?: string | null;
  updated_at?: string | null;
  resolved_at?: string | null;
  starts_at?: string | null;
  ends_at?: string | null;
  upcoming?: boolean;
}
export interface StudioReportRow {
  id: string;
  reason: string;
  details: string;
  created_at: string;
  reporter_label: string;
  subject_type: string;
  subject_label: string;
  event_id: string;
  comment_id: string;
  reported_user_id: string;
  event_hidden: boolean;
  legacy_admin_path: string;
}
export interface StudioVenueClaimRow {
  id: string;
  venue_id: string;
  venue_name: string;
  venue_address: string;
  claim_type: string;
  status: string;
  contact_name: string;
  contact_email: string;
  claimant_label: string;
  market_review_status: string;
  created_at: string;
  legacy_admin_path: string;
}
export interface StudioCustomVenueRow {
  venue_name: string;
  address: string;
  event_count: number /* int32 */;
}
export interface StudioIgnoredVenueRow {
  venue_name: string;
  address: string;
  created_at: string;
}
export interface StudioCustomVenueRequest {
  venue_name: string;
  address: string;
}
export interface StudioCustomVenueReconcileRequest {
  venue_name: string;
  address: string;
  venue_id?: string | null;
  create: boolean;
}
export interface StudioCustomVenueReconcileResult {
  venue: StudioVenueRow;
  linked_count: number /* int64 */;
}
export interface StudioOrganizationInvitationRequest {
  email: string;
  role: OrgRole;
  venue_ids?: string[];
}
export interface StudioVenueClaimRejectRequest {
  admin_notes: string;
  rejection_reason: string;
}
export interface StudioVenueClaimApproveRequest {
  verification_method: VenueVerificationMethod;
  admin_notes: string;
}
export interface StudioVenueClaimApproveResult {
  venue_name: string;
  transferred_count: number /* int32 */;
  remaining_count: number /* int32 */;
  owner_invite_sent_to: string;
  owner_invite_delivery_failed: boolean;
}
export interface StudioUserBanRequest {
  reason: string;
}
export interface StudioRejectedIntakeRow {
  id: string;
  title: string;
  venue_name: string;
  address: string;
  source: string;
  source_url: string;
  starts_at?: string | null;
  rejection_reason: string;
  created_at: string;
  legacy_admin_path: string;
}
export interface UpdatePrivacyRequest {
  location_tracking_enabled?: boolean | null;
}
export interface DataExportResponse {
  download_url: string;
  expires_at: string;
}
/**
 * SyncLocationRequest updates the authenticated user's latest resolved location.
 */
export interface SyncLocationRequest {
  lat: number /* float64 */;
  lng: number /* float64 */;
}
/**
 * EventHostSummary describes the event creator in discovery payloads.
 */
export interface EventHostSummary {
  user_id: string;
  username: string;
  display_name: string;
  avatar_url: string;
  bio?: string;
  is_public: boolean;
  is_following: boolean;
  is_staff: boolean;
  is_venue: boolean;
  venue_id?: string | null;
  venue_name: string;
  is_verified: boolean;
}
/**
 * EventCoordinate contains the event location in decimal degrees.
 */
export interface EventCoordinate {
  latitude: number /* float64 */;
  longitude: number /* float64 */;
}
export const EventPosterContentTypeJPEG = "image/jpeg";
export const EventPosterContentTypePNG = "image/png";
export const EventPosterContentTypeWEBP = "image/webp";
export const EventPosterContentTypeHEIC = "image/heic";
export type EventPosterContentType = typeof EventPosterContentTypeJPEG | typeof EventPosterContentTypePNG | typeof EventPosterContentTypeWEBP | typeof EventPosterContentTypeHEIC;
export const EventPosterMaxImagesPerEvent: number /* int32 */ = 5;
export const EventPosterMinImageWidth: number /* int32 */ = 800;
export const EventPosterMinImageHeight: number /* int32 */ = 1000;
export const EventPosterMaxImageFileSizeMB: number /* int32 */ = 10;
export const EventPosterFocalPointDefaultX: number /* float64 */ = 0.5;
export const EventPosterFocalPointDefaultY: number /* float64 */ = 0.3;
export const EventPosterFocalScaleDefault: number /* float64 */ = 1.0;
export interface EventPosterFocalPoint {
  x: number /* float64 */;
  y: number /* float64 */;
}
export interface EventPosterConstants {
  max_images_per_event: number /* int32 */;
  min_image_width: number /* int32 */;
  min_image_height: number /* int32 */;
  max_image_file_size_mb: number /* int32 */;
  supported_image_formats: EventPosterContentType[];
  focal_point_default: EventPosterFocalPoint;
}
export const EVENT_POSTER_CONSTANTS = {
  MAX_IMAGES_PER_EVENT: EventPosterMaxImagesPerEvent,
  MIN_IMAGE_WIDTH: EventPosterMinImageWidth,
  MIN_IMAGE_HEIGHT: EventPosterMinImageHeight,
  MAX_IMAGE_FILE_SIZE_MB: EventPosterMaxImageFileSizeMB,
  SUPPORTED_IMAGE_FORMATS: [
    EventPosterContentTypeJPEG,
    EventPosterContentTypePNG,
    EventPosterContentTypeWEBP,
    EventPosterContentTypeHEIC,
  ],
  FOCAL_POINT_DEFAULT: {
    x: EventPosterFocalPointDefaultX,
    y: EventPosterFocalPointDefaultY,
  },
} as const
export const UploadPurposeGeneric = "generic";
export const UploadPurposeEventPoster = "event_poster";
export const UploadPurposeVenueImage = "venue_image";
export type UploadPurpose = typeof UploadPurposeGeneric | typeof UploadPurposeEventPoster | typeof UploadPurposeVenueImage;
export type ImageUploadWarningCode = string;
export const ImageUploadWarningCodeEventPosterLowResolution: ImageUploadWarningCode = "event_poster_low_resolution";
export interface ImageUploadWarning {
  code: ImageUploadWarningCode;
  message: string;
}
/**
 * EventImageAsset is a persisted event poster image.
 */
export interface EventImageAsset {
  id: string;
  object_key: string;
  public_url: string;
  position: number /* int32 */;
  focal_point_x: number /* float64 */;
  focal_point_y: number /* float64 */;
  focal_scale: number /* float64 */;
}
/**
 * EventImageInput is the client payload for event poster images.
 */
export interface EventImageInput {
  object_key: string;
  public_url: string;
  position: number /* int32 */;
  focal_point_x?: number /* float64 */;
  focal_point_y?: number /* float64 */;
  focal_scale?: number /* float64 */;
}
/**
 * EventAttendeeSummary is the compact attendee preview shown on event detail and feed surfaces.
 */
export interface EventAttendeeSummary {
  user_id: string;
  username: string;
  display_name: string;
  avatar_url: string;
  is_friend: boolean;
}
/**
 * DiscoveryEvent is the list card representation for an event.
 */
export interface DiscoveryEvent {
  id: string;
  title: string;
  description: string;
  venue_id?: string | null;
  venue_name: string;
  address: string;
  age_restriction: EventAgeRestriction;
  starts_at: string;
  published_at?: string | null;
  ends_at?: string | null;
  poster_url: string;
  poster_images: EventImageAsset[];
  tags: string[];
  attributes: string[];
  rsvp_count: number /* int64 */;
  event_momentum: EventMomentum;
  recent_going_30m: number /* int64 */;
  recent_going_60m: number /* int64 */;
  comment_count: number /* int64 */;
  viewer_rsvp_status: string;
  is_saved: boolean;
  is_cancelled: boolean;
  status: EventStatus;
  host_is_curator: boolean;
  distance_miles: number /* float64 */;
  host: EventHostSummary;
  coordinate: EventCoordinate;
  summary: string;
  event_url?: string | null;
  ticket_url?: string | null;
  is_free: boolean;
  price?: string | null;
  entry_type: EntryType;
  cover_price?: number | null;
  is_private: boolean;
  is_boosted: boolean;
  boost_tier?: BoostTier;
  boost_expires_at?: string | null;
  doors_at?: string | null;
  canonical_owner_type: EventCanonicalOwnerType;
  is_owned_by_org: boolean;
  venue_is_claimed: boolean;
  source_fixture_id?: string | null;
  is_fixture_managed: boolean;
}
export interface EventOwnerStats {
  views: number /* int64 */;
  going: number /* int64 */;
  shares: number /* int64 */;
  nearby_percent: number /* int32 */;
}
/**
 * DiscoveryEventDetail is the detailed event view returned by GET /events/{id}.
 */
export interface DiscoveryEventDetail {
  id: string;
  title: string;
  description: string;
  venue_name: string;
  address: string;
  age_restriction: EventAgeRestriction;
  starts_at: string;
  published_at?: string | null;
  ends_at?: string | null;
  poster_url: string;
  tags: string[];
  attributes: string[];
  rsvp_count: number /* int64 */;
  comment_count: number /* int64 */;
  viewer_rsvp_status: string;
  is_saved: boolean;
  is_cancelled: boolean;
  status: EventStatus;
  host_is_curator: boolean;
  distance_miles: number /* float64 */;
  host: EventHostSummary;
  coordinate: EventCoordinate;
  summary: string;
  capacity: number /* int32 */;
  poster_images: EventImageAsset[];
  attendee_preview: EventAttendeeSummary[];
  event_url?: string | null;
  ticket_url?: string | null;
  is_free: boolean;
  price?: string | null;
  entry_type: EntryType;
  cover_price?: number | null;
  cover_notes?: string | null;
  rsvp_limit?: number | null;
  is_rsvp_full: boolean;
  is_at_capacity: boolean;
  last_entry_time?: string | null;
  short_description?: string | null;
  /**
   * Deprecated: event_hashtag has no active product surface. Remove from contracts in a future cleanup pass.
   */
  event_hashtag?: string | null;
  language: string;
  event_format?: EventFormat | null;
  dress_code?: string | null;
  parking_info?: string | null;
  presented_by?: string | null;
  weather_dependent: boolean;
  rain_plan?: string | null;
  contact_email?: string | null;
  contact_phone?: string | null;
  internal_notes?: string | null;
  is_private: boolean;
  is_boosted: boolean;
  boost_expires_at?: string | null;
  series_id?: string | null;
  cancelled_at?: string | null;
  cancellation_message?: string | null;
  venue_id?: string | null;
  canonical_owner_type: EventCanonicalOwnerType;
  is_owned_by_org: boolean;
  viewer_can_manage: boolean;
  viewer_can_cancel: boolean;
  venue_claimed: boolean;
  doors_at?: string | null;
  source_fixture_id?: string | null;
  is_fixture_managed: boolean;
  owner_stats?: EventOwnerStats | null;
  intake_diagnostics?: DiscordIntakeDiagnostics | null;
}
/**
 * CommentView is a rendered event comment.
 */
export interface CommentView {
  id: string;
  body: string;
  created_at: string;
  author: ProfileSummary;
  is_hidden: boolean;
  hidden_by_me: boolean;
}
/**
 * CommentsResponse wraps the event comments payload.
 */
export interface CommentsResponse {
  comments: CommentView[];
}
/**
 * ActivityItem is a single profile activity feed row.
 */
export interface ActivityItem {
  id: string;
  type: ActivityType;
  title: string;
  body: string;
  occurred_at: string;
  event_id?: string;
  actor_username: string;
}
/**
 * ActivityResponse wraps the activity feed payload.
 */
export interface ActivityResponse {
  activity: ActivityItem[];
}
/**
 * FriendActivityUserSummary is the public user shape used in passive social activity.
 */
export interface FriendActivityUserSummary {
  user_id: string;
  username: string;
  display_name: string;
  avatar_url: string;
}
/**
 * EventSummary is the compact event shape embedded in passive social activity.
 */
export interface EventSummary {
  id: string;
  title: string;
  venue_name: string;
  starts_at?: string | null;
  poster_url: string;
}
/**
 * FriendActivityItem is a passive social activity row from a mutual follow.
 */
export interface FriendActivityItem {
  type: FriendActivityType;
  actor: FriendActivityUserSummary;
  event?: EventSummary | null;
  target_user?: FriendActivityUserSummary | null;
  created_at: string;
}
/**
 * FriendActivityResponse wraps the passive social activity payload.
 */
export interface FriendActivityResponse {
  activity: FriendActivityItem[];
  has_more: boolean;
  offset: number /* int32 */;
  limit: number /* int32 */;
}
/**
 * PublicProfileStats contains public-facing profile counts.
 */
export interface PublicProfileStats {
  hosted_count: number /* int64 */;
  follower_count: number /* int64 */;
  following_count: number /* int64 */;
}
/**
 * ProfileRelationship describes how the viewer relates to a profile.
 */
export interface ProfileRelationship {
  is_self: boolean;
  is_following: boolean;
  follows_you: boolean;
  is_friend: boolean;
  is_blocked_by_me: boolean;
}
/**
 * DashboardStats contains the authenticated profile counts.
 */
export interface DashboardStats {
  hosted_count: number /* int64 */;
  going_count: number /* int64 */;
  saved_count: number /* int64 */;
  follower_count: number /* int64 */;
  following_count: number /* int64 */;
}
/**
 * DashboardProfile combines the base profile summary with private counts.
 */
export interface DashboardProfile {
  user_id: string;
  username: string;
  display_name: string;
  bio: string;
  avatar_url: string;
  is_public: boolean;
  visibility: ProfileVisibility;
  is_staff: boolean;
  is_venue: boolean;
  venue_id?: string | null;
  venue_name: string;
  default_rsvp_public: boolean;
  visiting: boolean;
  home_city?: string | null;
  last_county_name?: string | null;
  location_tracking_enabled: boolean;
  market_access: MarketAccess;
  interest_tags: string[];
  stats: DashboardStats;
}
/**
 * DashboardResult is the authenticated profile dashboard payload.
 */
export interface DashboardResult {
  profile: DashboardProfile;
  hosted_events: DiscoveryEvent[];
  going_events: DiscoveryEvent[];
  saved_events: DiscoveryEvent[];
  saved_deals: VenuePublicDeal[];
}
/**
 * DiscoveryFilters echoes the applied discovery search filters.
 */
export interface DiscoveryFilters {
  search: string;
  day: string;
  tag: string;
  attributes: string;
  sort: string;
  near_only: boolean;
}
/**
 * PaginatedEventsResult is the discovery list response.
 */
export interface PaginatedEventsResult {
  events: DiscoveryEvent[];
  next_offset?: number | null;
  has_more: boolean;
  filters: DiscoveryFilters;
}
/**
 * PublicProfileResult is the public profile page payload.
 */
export interface PublicProfileResult {
  profile: ProfileSummary;
  stats: PublicProfileStats;
  relationship: ProfileRelationship;
  hosted_events: DiscoveryEvent[];
  past_hosted_events: DiscoveryEvent[];
  public_rsvps: DiscoveryEvent[];
  default_rsvp_public?: boolean | null;
  visibility: PublicProfileVisibility;
  is_limited: boolean;
}
/**
 * ProfileResponse wraps profile mutation responses.
 */
export interface ProfileResponse {
  profile: ProfileSummary;
}
/**
 * EventRecord is the event payload returned by create and update mutations.
 */
export interface EventRecord {
  id: string;
  creator_user_id: string;
  title: string;
  description: string;
  venue_name: string;
  address: string;
  age_restriction: EventAgeRestriction;
  latitude: number /* float64 */;
  longitude: number /* float64 */;
  starts_at: string;
  published_at?: string | null;
  ends_at?: string | null;
  capacity: number /* int32 */;
  is_cancelled: boolean;
  created_at: string;
  updated_at: string;
  status: EventStatus;
  venue_id?: string | null;
  organization_id?: string | null;
  canonical_owner_type: EventCanonicalOwnerType;
  canonical_owner_user_id?: string | null;
  canonical_owner_organization_id?: string | null;
  tags: string[];
  attributes: string[];
  poster_images: EventImageAsset[];
  event_url?: string | null;
  ticket_url?: string | null;
  is_free: boolean;
  price?: string | null;
  entry_type: EntryType;
  cover_price?: number | null;
  cover_notes?: string | null;
  short_description?: string | null;
  seo_slug?: string | null;
  is_private: boolean;
  is_boosted: boolean;
  boost_expires_at?: string | null;
  series_id?: string | null;
  cancelled_at?: string | null;
  cancellation_message?: string | null;
  doors_at?: string | null;
  source_fixture_id?: string | null;
  is_fixture_managed: boolean;
}
/**
 * EventFlyerDuplicate describes whether a flyer looks like an already-listed event.
 */
export interface EventFlyerDuplicate {
  is_duplicate: boolean;
  event_id?: string | null;
  event_title?: string | null;
  similarity: number /* float64 */;
}
/**
 * EventFlyerExtraction contains the normalized event details read from a flyer.
 */
export interface EventFlyerExtraction {
  raw_date_text?: string | null;
  raw_doors_time_text?: string | null;
  raw_start_time_text?: string | null;
  raw_end_time_text?: string | null;
  raw_price_text?: string | null;
  raw_age_text?: string | null;
  raw_tag_clues: string[];
  raw_attribute_clues: string[];
  raw_last_entry_time_text?: string | null;
  short_factual_summary?: string | null;
  short_description?: string | null;
  title?: string | null;
  description?: string | null;
  venue_name?: string | null;
  address?: string | null;
  doors_at?: string | null;
  starts_at?: string | null;
  ends_at?: string | null;
  last_entry_time?: string | null;
  age_restriction?: EventAgeRestriction | null;
  tags: string[];
  attributes: string[];
  event_url?: string | null;
  ticket_url?: string | null;
  is_free?: boolean | null;
  price?: string | null;
  entry_type?: EntryType | null;
  cover_price?: number | null;
  cover_notes?: string | null;
  capacity?: number | null;
  poster_url?: string | null;
  rsvp_limit?: number | null;
  is_private: boolean;
  event_hashtag?: string | null;
  language?: string | null;
  event_format?: EventFormat | null;
  dress_code?: string | null;
  parking_info?: string | null;
  presented_by?: string | null;
  weather_dependent: boolean;
  rain_plan?: string | null;
  contact_email?: string | null;
  contact_phone?: string | null;
  confidence: number /* int32 */;
  is_event: boolean;
  rejection_reason?: string | null;
  decision: EventCurationDecision;
  decision_reason?: string | null;
  auto_approve: boolean;
  title_confidence?: number | null;
  venue_confidence?: number | null;
  date_confidence?: number | null;
  time_confidence?: number | null;
  price_confidence?: number | null;
  tags_confidence?: number | null;
}
/**
 * EventFlyerExtractionResult is the response from the flyer extraction helper.
 */
export interface EventFlyerExtractionResult {
  extracted: EventFlyerExtraction;
  duplicate?: EventFlyerDuplicate | null;
}
export interface CancelEventRequest {
  message?: string | null;
}
/**
 * RSVPRecord is the event RSVP payload returned by RSVP mutations.
 */
export interface RSVPRecord {
  user_id: string;
  event_id: string;
  status: string;
  is_public: boolean;
  visibility: RSVPVisibility;
  created_at: string;
  updated_at: string;
}
/**
 * FeedBannerType identifies the kind of feed banner shown to out-of-market users.
 */
export type FeedBannerType = string;
export const FeedBannerTypeOutsideMarket: FeedBannerType = "outside_market";
/**
 * FeedBanner is an inline message returned by GET /feed when the user is outside the service area.
 */
export interface FeedBanner {
  type: FeedBannerType;
  title: string;
  body: string;
}
export const FeedEventHintTypeFollowedVenue = "followed_venue";
export const FeedEventHintTypeFollowedHost = "followed_host";
export const FeedEventHintTypeInterestMatch = "interest_match";
export const FeedEventHintTypeFriendsGoing = "friends_going";
export const FeedEventHintTypePopular = "popular";
export const FeedEventHintTypeSoon = "soon";
export const FeedEventHintTypeNearYou = "near_you";
export const FeedEventHintTypeFeatured = "featured";
export type FeedEventHintType = typeof FeedEventHintTypeFollowedVenue | typeof FeedEventHintTypeFollowedHost | typeof FeedEventHintTypeInterestMatch | typeof FeedEventHintTypeFriendsGoing | typeof FeedEventHintTypePopular | typeof FeedEventHintTypeSoon | typeof FeedEventHintTypeNearYou | typeof FeedEventHintTypeFeatured;
export interface FeedEventHint {
  type: FeedEventHintType;
  label: string;
}
export const FeedPlacementTypeOrganic = "organic";
export const FeedPlacementTypePromoted = "promoted";
export type FeedPlacementType = typeof FeedPlacementTypeOrganic | typeof FeedPlacementTypePromoted;
export const FeedItemTypeEvent = "event";
export const FeedItemTypeDeal = "deal";
export type FeedItemType = typeof FeedItemTypeEvent | typeof FeedItemTypeDeal;
export const DealTimingStateArchived = "archived";
export const DealTimingStateLive = "live";
export const DealTimingStatePaused = "paused";
export const DealTimingStateScheduled = "scheduled";
export type DealTimingState = typeof DealTimingStateArchived | typeof DealTimingStateLive | typeof DealTimingStatePaused | typeof DealTimingStateScheduled;
export const FeedDealActionTypeDirections = "directions";
export const FeedDealActionTypeViewVenue = "view_venue";
export type FeedDealActionType = typeof FeedDealActionTypeDirections | typeof FeedDealActionTypeViewVenue;
export interface FeedDealAction {
  type: FeedDealActionType;
  label: string;
}
export interface FeedDealItem {
  deal: VenuePublicDeal;
  timing_state: DealTimingState;
  timing_label: string;
  primary_action: FeedDealAction;
  secondary_action: FeedDealAction;
  venue_address?: string;
  venue_verified: boolean;
}
export interface FeedItem {
  type: FeedItemType;
  event?: FeedEvent | null;
  deal?: FeedDealItem | null;
}
/**
 * FeedResponse wraps the location-aware feed payload with an optional service-area banner.
 */
export interface FeedResponse {
  events: FeedEvent[];
  items?: FeedItem[];
  deals: VenuePublicDeal[];
  banner?: FeedBanner;
  market_access: MarketAccess;
  is_fiesta_active: boolean;
}
/**
 * FeedEvent is the location-aware feed representation returned by GET /feed.
 */
export interface FeedEvent {
  id: string;
  creator_user_id: string;
  title: string;
  description: string;
  venue_id?: string | null;
  venue_name: string;
  address: string;
  age_restriction: EventAgeRestriction;
  latitude: number /* float64 */;
  longitude: number /* float64 */;
  starts_at: string;
  published_at?: string | null;
  ends_at?: string | null;
  capacity: number /* int32 */;
  is_cancelled: boolean;
  poster_url: string;
  poster_images: EventImageAsset[];
  tags: string[];
  going_count: number /* int64 */;
  event_momentum: EventMomentum;
  recent_going_30m: number /* int64 */;
  recent_going_60m: number /* int64 */;
  interested_count: number /* int64 */;
  friends_going_count: number /* int64 */;
  viewer_follows_host: boolean;
  viewer_follows_venue: boolean;
  viewer_not_interested: boolean;
  viewer_interest_score: number /* int64 */;
  matching_interest_tags: string[];
  discover_hint?: FeedEventHint;
  placement: FeedPlacementType;
  promotion_label?: string | null;
  attendee_preview: EventAttendeeSummary[];
  friend_preview: EventAttendeeSummary[];
  comment_count: number /* int64 */;
  user_has_rsvpd: boolean;
  viewer_rsvp_status: string;
  is_saved: boolean;
  host_is_curator: boolean;
  distance_meters: number /* float64 */;
  editorial_label?: string | null;
  launch_badges?: string[];
  fiesta_score: number /* float64 */;
  popularity_score: number /* float64 */;
  host: EventHostSummary;
  event_url?: string | null;
  ticket_url?: string | null;
  is_free: boolean;
  price?: string | null;
  attributes: string[];
  entry_type: EntryType;
  cover_price?: number | null;
  is_private: boolean;
  is_boosted: boolean;
  boost_tier?: BoostTier;
  boost_expires_at?: string | null;
  doors_at?: string | null;
}
/**
 * FollowStatusResponse returns whether the viewer currently follows a profile.
 */
export interface FollowStatusResponse {
  is_following: boolean;
}
/**
 * NotificationType identifies a client-visible notification variant.
 */
export const NotificationTypeFriendRSVP = "friend_rsvp";
export const NotificationTypeFollowAdded = "follow_added";
export const NotificationTypeEventComment = "event_comment";
export const NotificationTypeEventCancelled = "event_cancelled";
export const NotificationTypeHostNewEvent = "host_new_event";
export const NotificationTypeVenueNewEvent = "venue_new_event";
export const NotificationTypeVenueEventCancelled = "venue_event_cancelled";
export const NotificationTypeVenueLiveDeal = "venue_live_deal";
export const NotificationTypeVenueClaimApproved = "venue_claim_approved";
export const NotificationTypeVenueFollowed = "venue_followed";
export const NotificationTypeVenueRSVP = "venue_rsvp";
export const NotificationTypeVenueAnnouncement = "venue_announcement";
export const NotificationTypeEventBoost = "event_boost";
export const NotificationTypeGoingEventStartingSoon = "going_event_starting_soon";
export const NotificationTypeSavedEventStartingSoon = "saved_event_starting_soon";
export const NotificationTypeWeeklyDigest = "weekly_digest";
export const NotificationTypeOrganizationInviteReceived = "organization_invite_received";
export const NotificationTypeOrganizationInviteAccepted = "organization_invite_accepted";
export const NotificationTypeOrganizationMemberUpdated = "organization_member_updated";
export const NotificationTypeOrganizationMemberRemoved = "organization_member_removed";
export const NotificationTypeOwnerHandoffStarted = "owner_handoff_started";
export const NotificationTypeOwnerSetupCompleted = "owner_setup_completed";
export type NotificationType = typeof NotificationTypeFriendRSVP | typeof NotificationTypeFollowAdded | typeof NotificationTypeEventComment | typeof NotificationTypeEventCancelled | typeof NotificationTypeHostNewEvent | typeof NotificationTypeVenueNewEvent | typeof NotificationTypeVenueEventCancelled | typeof NotificationTypeVenueLiveDeal | typeof NotificationTypeVenueClaimApproved | typeof NotificationTypeVenueFollowed | typeof NotificationTypeVenueRSVP | typeof NotificationTypeVenueAnnouncement | typeof NotificationTypeEventBoost | typeof NotificationTypeGoingEventStartingSoon | typeof NotificationTypeSavedEventStartingSoon | typeof NotificationTypeWeeklyDigest | typeof NotificationTypeOrganizationInviteReceived | typeof NotificationTypeOrganizationInviteAccepted | typeof NotificationTypeOrganizationMemberUpdated | typeof NotificationTypeOrganizationMemberRemoved | typeof NotificationTypeOwnerHandoffStarted | typeof NotificationTypeOwnerSetupCompleted;
export const NotificationScopePersonal = "personal";
export const NotificationScopeOrganization = "organization";
export const NotificationScopeVenue = "venue";
export type NotificationScope = typeof NotificationScopePersonal | typeof NotificationScopeOrganization | typeof NotificationScopeVenue;
export const NotificationSurfacePersonal = "personal";
export const NotificationSurfaceBusiness = "business";
export type NotificationSurface = typeof NotificationSurfacePersonal | typeof NotificationSurfaceBusiness;
export const EmailPreferenceTypeReminders = "reminders";
export const EmailPreferenceTypeDigest = "digest";
export const EmailPreferenceTypeMarketing = "marketing";
export const EmailPreferenceTypeNewEvents = "new_events";
export const EmailPreferenceTypeFriendActivity = "friend_activity";
export const EmailPreferenceTypeVenueUpdates = "venue_updates";
export const EmailPreferenceTypeProductUpdates = "product_updates";
export const EmailPreferenceTypeAll = "all";
export type EmailPreferenceType = typeof EmailPreferenceTypeReminders | typeof EmailPreferenceTypeDigest | typeof EmailPreferenceTypeMarketing | typeof EmailPreferenceTypeNewEvents | typeof EmailPreferenceTypeFriendActivity | typeof EmailPreferenceTypeVenueUpdates | typeof EmailPreferenceTypeProductUpdates | typeof EmailPreferenceTypeAll;
export type NotificationDestination = string;
export const NotificationDestinationRoute: NotificationDestination = "route";
export const ExpoPushReceiptStatusOK = "ok";
export const ExpoPushReceiptStatusError = "error";
export type ExpoPushReceiptStatus = typeof ExpoPushReceiptStatusOK | typeof ExpoPushReceiptStatusError;
export const ExpoPushReceiptErrorDeviceNotRegistered = "DeviceNotRegistered";
export const ExpoPushReceiptErrorBadDeviceToken = "BadDeviceToken";
export type ExpoPushReceiptError = typeof ExpoPushReceiptErrorDeviceNotRegistered | typeof ExpoPushReceiptErrorBadDeviceToken;
/**
 * NotificationPayload is the structured notification metadata shared with clients.
 */
export interface NotificationPayload {
  type: NotificationType;
  scope: NotificationScope;
  destination: NotificationDestination;
  route: string;
  title: string;
  organization_id?: string | null;
  event_id?: string | null;
  subject_user_id?: string | null;
  venue_id?: string | null;
  avatar_url?: string;
  image_url?: string;
  display_name?: string;
  username: string;
  copy: string;
}
/**
 * NotificationItem is a single user notification.
 */
export interface NotificationItem {
  id: string;
  type: NotificationType;
  event_id?: string | null;
  payload: NotificationPayload;
  is_read: boolean;
  created_at: string;
}
/**
 * NotificationsResponse wraps the notification list payload.
 */
export interface NotificationsResponse {
  notifications: NotificationItem[];
}
/**
 * NotificationPreferences stores the authenticated user's delivery choices.
 */
export interface NotificationPreferences {
  push_enabled: boolean;
  social_enabled: boolean;
  reminders_enabled: boolean;
  host_updates_enabled: boolean;
  venue_rsvp_enabled: boolean;
  weekly_digest_enabled: boolean;
}
/**
 * NotificationPreferencesResponse wraps the settings payload.
 */
export interface NotificationPreferencesResponse {
  preferences: NotificationPreferences;
}
/**
 * PatchNotificationPreferencesRequest is the request body for PATCH /me/notification-preferences.
 */
export interface PatchNotificationPreferencesRequest {
  push_enabled?: boolean | null;
  social_enabled?: boolean | null;
  reminders_enabled?: boolean | null;
  host_updates_enabled?: boolean | null;
  venue_rsvp_enabled?: boolean | null;
  weekly_digest_enabled?: boolean | null;
}
export interface EmailPreferences {
  email_reminders: boolean;
  email_digest: boolean;
  email_marketing: boolean;
  email_new_events: boolean;
  email_friend_activity: boolean;
  email_venue_updates: boolean;
  email_product_updates: boolean;
  email_unsubscribed_all: boolean;
}
export interface UpdateEmailPreferencesRequest {
  email_reminders?: boolean | null;
  email_digest?: boolean | null;
  email_marketing?: boolean | null;
  email_new_events?: boolean | null;
  email_friend_activity?: boolean | null;
  email_venue_updates?: boolean | null;
  email_product_updates?: boolean | null;
  email_unsubscribed_all?: boolean | null;
}
/**
 * PresignedUpload is the upload instruction returned by POST /uploads/sign.
 */
export interface PresignedUpload {
  method: string;
  url: string;
  headers: { [key: string]: string};
  object_key: string;
  public_url: string;
  expires_at: string;
  content_type: string;
  warnings?: ImageUploadWarning[];
}
export type HealthStatus = string;
export type HealthCheckMode = string;
export type HealthComponentName = string;
export interface HealthComponent {
  name: HealthComponentName;
  status: HealthStatus;
  required: boolean;
  mode: HealthCheckMode;
  latency_ms?: number /* int64 */;
  detail?: string;
  error?: string;
}
/**
 * HealthResponse is the API health payload.
 */
export interface HealthResponse {
  status: HealthStatus;
  checked_at: string;
  components?: HealthComponent[];
}
/**
 * GeocodeResult contains the resolved coordinates for an address.
 */
export interface GeocodeResult {
  lat: number /* float64 */;
  lng: number /* float64 */;
}
/**
 * GeocodeSuggestion is a single address autocomplete suggestion.
 */
export interface GeocodeSuggestion {
  display_name: string;
  lat: number /* float64 */;
  lng: number /* float64 */;
}
/**
 * SignupRequest is the request body for POST /auth/signup.
 */
export interface SignupRequest {
  email: string;
  password: string;
  username: string;
  display_name: string;
}
/**
 * GeocodeRequest is the request body for POST /geocode.
 */
export interface GeocodeRequest {
  address: string;
}
/**
 * LoginRequest is the request body for POST /auth/login.
 */
export interface LoginRequest {
  email: string;
  password: string;
}
/**
 * RefreshRequest is the request body for token refresh and logout.
 */
export interface RefreshRequest {
  refresh_token: string;
}
/**
 * PasswordResetRequest is the request body for POST /auth/password/reset/request.
 */
export interface PasswordResetRequest {
  email: string;
  /**
   * BaseURL is accepted for older clients but ignored; reset links use configured server hosts.
   */
  base_url?: string;
}
/**
 * PasswordResetConfirmRequest is the request body for POST /auth/password/reset/confirm.
 */
export interface PasswordResetConfirmRequest {
  token: string;
  password: string;
}
/**
 * SetPasswordRequest is the request body for POST /me/password/set.
 */
export interface SetPasswordRequest {
  password: string;
}
/**
 * CreateCommentRequest is the request body for POST /events/{eventID}/comments.
 */
export interface CreateCommentRequest {
  body: string;
}
/**
 * CreateSavedEventRequest is the request body for POST /saved-events.
 */
export interface CreateSavedEventRequest {
  event_id: string;
  qr_slug?: string;
  attributed_at?: string | null;
}
/**
 * CreateSavedVenueDealRequest is the request body for POST /saved-deals.
 */
export interface CreateSavedVenueDealRequest {
  deal_id: string;
}
/**
 * RSVPRequest is the request body for POST /events/{eventID}/rsvp.
 */
export interface RSVPRequest {
  status: string;
  is_public?: boolean | null;
  visibility?: RSVPVisibility | null;
  source?: RsvpSource | null;
  surface?: AnalyticsSurface | null;
  qr_slug?: string;
  attributed_at?: string | null;
}
/**
 * CreateRSVPRequest is the request body for POST /rsvp.
 */
export interface CreateRSVPRequest {
  event_id: string;
  status: string;
  is_public?: boolean | null;
  visibility?: RSVPVisibility | null;
  source?: RsvpSource | null;
  surface?: AnalyticsSurface | null;
  qr_slug?: string;
  attributed_at?: string | null;
}
/**
 * PatchMeRequest is the request body for PATCH /me.
 */
export interface PatchMeRequest {
  is_public?: boolean | null;
  visibility?: ProfileVisibility | null;
  profile_visibility?: ProfileVisibility | null;
}
/**
 * PatchProfileRequest is the request body for PATCH /profile.
 */
export interface PatchProfileRequest {
  username?: string | null;
  display_name?: string | null;
  bio?: string | null;
  avatar_url?: string | null;
  default_rsvp_public?: boolean | null;
  interest_tags?: string[];
}
export interface CreateEventFeedbackRequest {
  feedback: EventFeedbackType;
}
export interface PatchVenueRequest {
  name: string;
  slug?: string | null;
  description: string;
  category: VenueCategory;
  address: string;
  phone: string;
  website: string;
  booking_url: string;
  logo_url: string;
  cover_url: string;
  logo_focal_point_x?: number | null;
  logo_focal_point_y?: number | null;
  logo_focal_scale?: number | null;
  cover_focal_point_x?: number | null;
  cover_focal_point_y?: number | null;
  cover_focal_scale?: number | null;
  age_restriction: EventAgeRestriction;
  tags: string[];
  social_links: VenueSocialLink[];
  hours: VenueHour[];
}
export interface UpsertVenueDealRequest {
  title: string;
  description: string;
  category: VenueDealCategory;
  active_days: VenueWeekday[];
  starts_at_local: string;
  ends_at_local: string;
}
export interface VenueDealDateExceptionRequest {
  date: string;
}
export interface UpsertVenueFixtureRequest {
  title: string;
  description: string;
  active_days: VenueWeekday[];
  starts_at_local: string;
  ends_at_local: string;
  age_restriction: EventAgeRestriction;
  capacity: number /* int32 */;
  tags: string[];
  event_url: string;
  ticket_url: string;
  is_free: boolean;
  price: string;
  poster_images: EventImageInput[];
}
/**
 * CreateEventRequest is the request body for POST /events.
 */
export interface CreateEventRequest {
  title: string;
  description: string;
  venue_name: string;
  address: string;
  venue_id?: string | null;
  age_restriction: EventAgeRestriction;
  latitude: number /* float64 */;
  longitude: number /* float64 */;
  starts_at: string;
  ends_at?: string | null;
  capacity?: number | null;
  tags: string[];
  attributes: string[];
  poster_images: EventImageInput[];
  event_url?: string | null;
  ticket_url?: string | null;
  is_free: boolean;
  price?: string | null;
  doors_at?: string | null;
  entry_type: EntryType;
  cover_price?: number | null;
  cover_notes?: string | null;
  rsvp_limit?: number | null;
  is_private: boolean;
  last_entry_time?: string | null;
  short_description?: string | null;
  seo_slug?: string | null;
  /**
   * Deprecated: event_hashtag has no active product surface. Remove from contracts in a future cleanup pass.
   */
  event_hashtag?: string | null;
  language: string;
  event_format?: EventFormat | null;
  dress_code?: string | null;
  parking_info?: string | null;
  presented_by?: string | null;
  weather_dependent: boolean;
  rain_plan?: string | null;
  has_radious_tickets: boolean;
  cross_post_meta: boolean;
  contact_email?: string | null;
  contact_phone?: string | null;
  internal_notes?: string | null;
  series_id?: string | null;
}
/**
 * RewriteEventDescriptionRequest is the request body for POST /events/rewrite-description.
 */
export interface RewriteEventDescriptionRequest {
  title: string;
  venue_name: string;
  venue_id?: string | null;
  address: string;
  starts_at: string;
  ends_at: string;
  price: string;
  age_restriction: EventAgeRestriction;
  tags: string[];
  source_url: string;
  existing_description: string;
}
/**
 * RewriteEventDescriptionResult is the response from the description rewrite helper.
 */
export interface RewriteEventDescriptionResult {
  description: string;
}
/**
 * UpdateEventRequest is the request body for PATCH /events/{eventID}.
 */
export interface UpdateEventRequest {
  title: string;
  description: string;
  venue_name: string;
  address: string;
  venue_id?: string | null;
  age_restriction: EventAgeRestriction;
  latitude: number /* float64 */;
  longitude: number /* float64 */;
  starts_at: string;
  ends_at?: string | null;
  capacity?: number | null;
  tags: string[];
  attributes: string[];
  poster_images: EventImageInput[];
  event_url?: string | null;
  ticket_url?: string | null;
  is_free: boolean;
  price?: string | null;
  doors_at?: string | null;
  entry_type: EntryType;
  cover_price?: number | null;
  cover_notes?: string | null;
  rsvp_limit?: number | null;
  is_private: boolean;
  last_entry_time?: string | null;
  short_description?: string | null;
  seo_slug?: string | null;
  /**
   * Deprecated: event_hashtag has no active product surface. Remove from contracts in a future cleanup pass.
   */
  event_hashtag?: string | null;
  language: string;
  event_format?: EventFormat | null;
  dress_code?: string | null;
  parking_info?: string | null;
  presented_by?: string | null;
  weather_dependent: boolean;
  rain_plan?: string | null;
  has_radious_tickets: boolean;
  cross_post_meta: boolean;
  contact_email?: string | null;
  contact_phone?: string | null;
  internal_notes?: string | null;
  series_id?: string | null;
}
/**
 * SignUploadRequest is the request body for POST /uploads/sign.
 */
export interface SignUploadRequest {
  file_name: string;
  content_type: string;
  purpose?: UploadPurpose;
  file_size_bytes?: number /* int64 */;
  image_width?: number /* int32 */;
  image_height?: number /* int32 */;
}
/**
 * PatchEventPosterFocalPointRequest is the request body for PATCH /events/{eventID}/poster-images/{imageID}/focal-point.
 */
export interface PatchEventPosterFocalPointRequest {
  focal_point_x: number /* float64 */;
  focal_point_y: number /* float64 */;
  focal_scale: number /* float64 */;
}
/**
 * PatchOrganizationRequest is the request body for PATCH /organizations/{id}.
 */
export interface PatchOrganizationRequest {
  name?: string | null;
  slug?: string | null;
  phone?: string | null;
  billing_email?: string | null;
  website_url?: string | null;
}
